/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AdminDocumentMatchRequest {
  countryCode: string;
  fileName: string;
}

export interface AdminDocumentResponse {
  /** @format int32 */
  id: number;
  fileName: string;
  countryCode: string;
  countryName?: string | null;

  /** @format int32 */
  detailId?: number;
  detailName: string;
  detailDescription: string;
  documentCategory: DocumentCategory;

  /** @format date-time */
  createdAt?: string;

  /** @format date-time */
  updatedAt?: string;
  documentLevel: DocumentLevel;
  isExported?: boolean;
  isKpExported?: boolean;
}

export interface AdminMaterialGroupResponse {
  /** @format int32 */
  id?: number;
  materialGroupDescription?: string | null;
  materialGroupName?: string | null;

  /** @format int32 */
  productGroupId?: number;
}

export interface AdminProductGroupResponse {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  divisionId?: number;
  productGroupDescription?: string | null;
  productGroupName?: string | null;
}

export interface AdminUpdateDocumentRequest {
  /** @format int32 */
  id: number;
  countryCode: string;

  /** @format int32 */
  detailId?: number;
  detailName: string;
  documentCategory: DocumentCategory;
  documentLevel: DocumentLevel;
  isExported?: boolean;
  isKpExported?: boolean;
}

export interface AdvantageRequest {
  /** @format int32 */
  advantageId?: number;
  advantageName?: string | null;

  /** @format int32 */
  descriptionId?: number;

  /** @format int32 */
  displayOrder?: number;
}

export interface AdvantageResponse {
  /** @format int32 */
  advantageId?: number;
  advantageName?: string | null;

  /** @format int32 */
  descriptionId?: number;

  /** @format int32 */
  displayOrder?: number;
}

export interface ArrangementLayoutResponse {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  articleId?: number;
  countryCode?: string | null;
  fileName?: string | null;
  displayName?: string | null;
}

export interface ArticleExportRequest {
  countryCode: string;
  materialGroupIds: number[];
  productTypeCodes?: string[] | null;
}

export interface ArticleResponse {
  /** @format int32 */
  id?: number;
  articleNumber?: string | null;
  articleCountryNumber?: string | null;
  articleDescription?: string | null;
  articleCharacter?: string | null;
  arrangementLayouts?: ArrangementLayoutResponse[] | null;
  ean?: string | null;

  /** @format double */
  fillingVolume?: number | null;
  unitOfMeasure?: string | null;
  containerType?: string | null;

  /** @format double */
  palletNumberOfContainers?: number | null;

  /** @format double */
  overCartonNumberOfContainers?: number | null;

  /** @format double */
  net?: number;

  /** @format double */
  gross?: number | null;
  mainSupplier?: string | null;

  /** @format double */
  grossPrice?: number | null;
  supplierName?: string | null;

  /** @format double */
  priceReference?: number | null;
  priceUnit?: string | null;
  createdBy?: string | null;

  /** @format date-time */
  createdAt?: string;
  productType?: ProductTypeResponse;
  isGlobal?: boolean;
  isActive?: boolean;
  erpImport?: boolean;
  countryCode?: string | null;
  articleNumberComplexB?: string | null;
  priceGroup?: string | null;
  v5TextColumn1?: string | null;
  v5TextColumn2?: string | null;
  color?: string | null;
}

export interface AssemblyInformation {
  name?: string | null;
  location?: string | null;
  version?: string | null;
}

export interface BreadCrumbInfoResponseModel {
  name?: string | null;

  /** @format int32 */
  id?: number;
}

export interface CategoryResponse {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface ClaimInfo {
  type?: string | null;
  value?: string | null;
}

export interface CommentRequest {
  realName?: string | null;
  commentText?: string | null;

  /** @format int32 */
  materialGroupId?: number;
}

export interface CommentResponse {
  realName?: string | null;
  commentText?: string | null;

  /** @format date-time */
  dateTime?: string;

  /** @format int32 */
  materialGroupId?: number;

  /** @format int32 */
  id?: number;
}

export enum CountryPermission {
  Read = 'Read',
  Write = 'Write',
  AdministrationRead = 'AdministrationRead',
  AdministrationWrite = 'AdministrationWrite',
  CreateMaterialGroup = 'CreateMaterialGroup',
  UpdateMaterialGroup = 'UpdateMaterialGroup',
  DeleteMaterialGroup = 'DeleteMaterialGroup',
  CreateProductGroup = 'CreateProductGroup',
  UpdateProductGroup = 'UpdateProductGroup',
  DeleteProductGroup = 'DeleteProductGroup',
}

export interface CountryPermissionsGroupResponse {
  countryCode: string;
  permissions: CountryPermission[];
}

export interface CountryResponse {
  code?: string | null;
  name?: string | null;

  /** @format int32 */
  order?: number;
  defaultCultureCode?: string | null;
}

export interface CreateMailRequest {
  countryCode?: string | null;
  eMail?: string | null;
}

export interface CultureDefinition {
  cultureCode: string;
  isActive?: boolean;
}

export interface CustomerPortalDivisionResponse {
  divisionName?: string | null;
  divisionDescription?: string | null;
  technicalDataSheetList?: ExportFileDataResponse[] | null;
  safetyDataSheetList?: ExportFileDataResponse[] | null;
  infoSheetList?: ExportFileDataResponse[] | null;
  printingDataList?: ExportFileDataResponse[] | null;
  declarationOfPerformanceList?: ExportFileDataResponse[] | null;
  externalLayoutList?: ExportFileDataResponse[] | null;
  testCertificateList?: ExportFileDataResponse[] | null;
  documentsList?: ExportFileDataResponse[] | null;
  picturesList?: ExportFileDataResponse[] | null;
  productGroups?: CustomerPortalProductGroupResponse[] | null;
  environmentalProductDeclarationList?: ExportFileDataResponse[] | null;
}

export interface CustomerPortalMaterialGroupResponse {
  materialGroupDescription?: string | null;
  materialGroupName?: string | null;
  productDescriptionLong?: string | null;
  advantage1?: string | null;
  advantage2?: string | null;
  advantage3?: string | null;
  advantage4?: string | null;
  advantage5?: string | null;
  color?: string | null;
  consumption?: string | null;
  materialGroupImage?: ExportFileDataResponse;
  pictogramList?: ExportFileDataResponse[] | null;
  sealOfAprovalList?: ExportFileDataResponse[] | null;
  technicalDataSheetList?: ExportFileDataResponse[] | null;
  safetyDataSheetList?: ExportFileDataResponse[] | null;
  infoSheetList?: ExportFileDataResponse[] | null;
  printingDataList?: ExportFileDataResponse[] | null;
  declarationOfPerformanceList?: ExportFileDataResponse[] | null;
  externalLayoutList?: ExportFileDataResponse[] | null;
  testCertificateList?: ExportFileDataResponse[] | null;
  documentsList?: ExportFileDataResponse[] | null;
  picturesList?: ExportFileDataResponse[] | null;
  environmentalProductDeclarationList?: ExportFileDataResponse[] | null;
}

export interface CustomerPortalProductGroupResponse {
  productGroupName?: string | null;
  productGroupDescription?: string | null;
  technicalDataSheetList?: ExportFileDataResponse[] | null;
  safetyDataSheetList?: ExportFileDataResponse[] | null;
  infoSheetList?: ExportFileDataResponse[] | null;
  printingDataList?: ExportFileDataResponse[] | null;
  declarationOfPerformanceList?: ExportFileDataResponse[] | null;
  externalLayoutList?: ExportFileDataResponse[] | null;
  testCertificateList?: ExportFileDataResponse[] | null;
  documentsList?: ExportFileDataResponse[] | null;
  picturesList?: ExportFileDataResponse[] | null;
  materialGroups?: CustomerPortalMaterialGroupResponse[] | null;
  environmentalProductDeclarationList?: ExportFileDataResponse[] | null;
}

export interface DescriptionRequestModel {
  /** @format int32 */
  id?: number;
  newProduct?: boolean;
  advantage?: AdvantageRequest[] | null;
  productDescriptionLong?: string | null;
  productDescriptionShort?: string | null;
  productTitle?: string | null;
}

export interface DescriptionResponseModel {
  /** @format int32 */
  id?: number;
  newProduct?: boolean;
  advantage?: AdvantageResponse[] | null;
  productDescriptionLong?: string | null;
  productDescriptionShort?: string | null;

  /** @format int32 */
  materialGroupId?: number;
  productTitle?: string | null;
  countryCode?: string | null;
}

export interface DiagnosticInformation {
  environmentName?: string | null;
  serverTimeUtc?: string | null;
  serverTime?: string | null;
  startTimeUtc?: string | null;
  startTime?: string | null;
  runningTime?: string | null;
  uniqueInstanceId?: string | null;
  binaryCreationTime?: string | null;
  binaryCreationTimeUtc?: string | null;
  assemblyVersion?: string | null;
  applicationControllerVersion?: string | null;
  dotNetVersion?: string | null;
  hostName?: string | null;
  requestHeaders?: Record<string, string | null>;
  osVersion?: OperatingSystem;

  /** @format int32 */
  processorCount?: number;

  /** @format int32 */
  processId?: number;
  threadUICulture?: string | null;
  threadCulture?: string | null;
  claims?: ClaimInfo[] | null;
  installedRuntimes?: string[] | null;
  installedSdks?: string[] | null;
  loadedAssemblies?: AssemblyInformation[] | null;
}

export interface DivisionCountryRequestModel {
  /** @format int32 */
  divisionId?: number;
  countryCode?: string | null;
  divisionDescription?: string | null;
}

export interface DivisionCountryResponseModel {
  /** @format int32 */
  id: number;

  /** @format int32 */
  divisionId?: number;
  divisionName?: string | null;
  originalCountryCode?: string | null;
  countryCode?: string | null;
  originalDivisionDescription?: string | null;
  divisionCountryDescription?: string | null;
}

export interface DivisionResponseModel {
  /** @format int32 */
  id?: number;
  divisionName?: string | null;
  divisionDescription?: string | null;
  divisionColor?: string | null;
  divisionCountries?: DivisionCountryResponseModel[] | null;
}

export interface DivisionTreeResponse {
  /** @format int32 */
  id: number;
  name: string;
  description?: string | null;
  productGroups: ProductGroupTreeResponse[];
}

export enum DocumentCategory {
  TechnicalDataSheet = 'TechnicalDataSheet',
  ExternalLayout = 'ExternalLayout',
  SafetyDataSheet = 'SafetyDataSheet',
  DeclarationOfPerformance = 'DeclarationOfPerformance',
  InfoSheet = 'InfoSheet',
  TestCertificate = 'TestCertificate',
  PrintingData = 'PrintingData',
  Documents = 'Documents',
  Pictures = 'Pictures',
  EnvironmentalProductDeclaration = 'EnvironmentalProductDeclaration',
}

export interface DocumentDetailOptionResponse {
  /** @format int32 */
  detailId: number;
  detailName: string;
  detailDescription: string;
  documentLevel: DocumentLevel;
}

export enum DocumentLevel {
  Division = 'Division',
  ProductGroup = 'ProductGroup',
  MaterialGroup = 'MaterialGroup',
}

export interface DocumentResponse {
  /** @format int32 */
  id: number;
  documentLevel: DocumentLevel;

  /** @format int32 */
  detailId?: number;
  detailName?: string | null;
  detailDescription?: string | null;
  countryCode?: string | null;
  fileName: string;

  /** @format int64 */
  fileSize: number;
  category: DocumentCategory;
  createdBy?: string | null;

  /** @format date-time */
  createdAt?: string;
  updatedBy: string;

  /** @format date-time */
  updatedAt: string;
  isExported: boolean;
  isKpExported: boolean;
}

export interface DocumentsGroup {
  category: DocumentCategory;
  documents: DocumentResponse[];
}

export interface ERPImportDataRequest {
  divisionName?: string | null;
  productGroupName?: string | null;
  productGroupDescription?: string | null;
  materialGroupName?: string | null;
  materialGroupDescription?: string | null;
  articleNumber?: string | null;
  articleDescription?: string | null;
  articleCharacter?: string | null;
  ean?: string | null;

  /** @format double */
  fillingVolume?: number;
  unitOfMeasure?: string | null;
  containerType?: string | null;

  /** @format double */
  numberOfPallets?: number;

  /** @format double */
  overCartonNumberOfContainer?: number;

  /** @format double */
  net?: number;

  /** @format double */
  gross?: number;
  mainSupplier?: string | null;
  supplierName?: string | null;
  productType?: string | null;

  /** @format double */
  grossPrice?: number;
  createdBy?: string | null;

  /** @format date-time */
  createdAt?: string;

  /** @format int32 */
  durability?: number;

  /** @format double */
  priceReferenceQuantity?: number;
  priceUnit?: string | null;
  divisionColor?: string | null;
}

export interface ERPImportRequest {
  erpImportData?: ERPImportDataRequest[] | null;
}

export interface ERPImportResponse {
  /** @format int32 */
  runId?: number;
  createdBy?: string | null;

  /** @format date-time */
  createdAt?: string;
  updatedBy?: string | null;

  /** @format date-time */
  updatedAt?: string;

  /** @format int32 */
  numberOfEntries?: number;
}

export interface ExportFileDataResponse {
  Url?: string | null;

  /** @format date-time */
  LastModified?: string;
  Dateiname?: string | null;
}

export interface GeneralHintRequest {
  /** @format int32 */
  id?: number;
  countryCode?: string | null;
  content?: string | null;
}

export interface GeneralHintResponse {
  /** @format int32 */
  id?: number;
  countryCode?: string | null;
  countryName?: string | null;
  content?: string | null;
}

export enum GlobalPermission {
  Read = 'Read',
  QuickLinkWrite = 'QuickLinkWrite',
  AdministrationRead = 'AdministrationRead',
  AdministrationWrite = 'AdministrationWrite',
  AdminProductAndMaterialGroupWrite = 'AdminProductAndMaterialGroupWrite',
  ApiKeyGenerate = 'ApiKeyGenerate',
}

export interface ImageStoreResponse {
  /** @format int32 */
  id: number;

  /** @format int32 */
  materialGroupId?: number | null;
  defaultImage?: boolean;
  fileName?: string | null;

  /** @format int32 */
  fileSize?: number;
  materialGroupDescription?: string | null;

  /** @format uuid */
  azureStorageGuid?: string;
  updatedBy?: string | null;

  /** @format date-time */
  updatedAt?: string;
  createdBy?: string | null;

  /** @format date-time */
  createdAt?: string;
}

export interface LocalizationDefinition {
  cultureDefinitions: CultureDefinition[];
  translationSections: LocalizationSectionCode[];
}

export enum LocalizationSectionCode {
  STATIC = 'STATIC',
}

export interface LocalizationTextModel {
  sectionCode: string;
  textCode: string;
  translations: Record<string, string | null>;
}

export interface MailNotificationRequest {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  materialGroupId?: number;
  subject?: string | null;
  body?: string | null;
  selectedMailingListCodes?: string[] | null;
}

export interface MailResponse {
  /** @format int32 */
  id: number;
  countryCode?: string | null;
  eMail: string;
}

export interface MailingListResponse {
  countryCode: string;
  mailingList?: MailResponse[] | null;
}

export interface MaterialGroupAttributeResponse {
  labelKey: string;
  type: MaterialGroupAttributeType;
}

export enum MaterialGroupAttributeType {
  MaterialGroupName = 'MaterialGroupName',
  MaterialGroupDescription = 'MaterialGroupDescription',
  ProductGroupName = 'ProductGroupName',
  ProductGroupDescription = 'ProductGroupDescription',
  DivisionName = 'DivisionName',
  DivisionDescription = 'DivisionDescription',
  TechnicalDetailChemicalBase = 'TechnicalDetail_ChemicalBase',
  TechnicalDetailDense = 'TechnicalDetail_Dense',
  TechnicalDetailBulkDensity = 'TechnicalDetail_BulkDensity',
  TechnicalDetailFreshMortarDensity = 'TechnicalDetail_FreshMortarDensity',
  TechnicalDetailLargestGrain = 'TechnicalDetail_LargestGrain',
  TechnicalDetailSolidStateContent = 'TechnicalDetail_SolidStateContent',
  TechnicalDetailViscosity = 'TechnicalDetail_Viscosity',
  TechnicalDetailUValue = 'TechnicalDetail_uValue',
  TechnicalDetailSDValue = 'TechnicalDetail_SDValue',
  TechnicalDetailPhValue = 'TechnicalDetail_PhValue',
  TechnicalDetailAppearance = 'TechnicalDetail_Appearance',
  TechnicalDetailColor = 'TechnicalDetail_Color',
  TechnicalDetailGloss = 'TechnicalDetail_Gloss',
  TechnicalDetailConsumption = 'TechnicalDetail_Consumption',
  TechnicalDetailProductiveness = 'TechnicalDetail_Productiveness',
  TechnicalDetailWaterDemand = 'TechnicalDetail_WaterDemand',
  TechnicalDetailMixingRatio = 'TechnicalDetail_MixingRatio',
  TechnicalDetailDilution = 'TechnicalDetail_Dilution',
  TechnicalDetailLayerThickness = 'TechnicalDetail_LayerThickness',
  TechnicalDetailJointWidth = 'TechnicalDetail_JointWidth',
  TechnicalDetailDryFilmThickness = 'TechnicalDetail_DryFilmThickness',
  TechnicalDetailVentilationTime = 'TechnicalDetail_VentilationTime',
  TechnicalDetailInsertionTime = 'TechnicalDetail_InsertionTime',
  TechnicalDetailReadyForPublishing = 'TechnicalDetail_ReadyForPublishing',
  TechnicalDetailRainproof = 'TechnicalDetail_Rainproof',
  TechnicalDetailFinalStrength = 'TechnicalDetail_FinalStrength',
  TechnicalDetailGrindability = 'TechnicalDetail_Grindability',
  TechnicalDetailMechanicallyResilient = 'TechnicalDetail_MechanicallyResilient',
  TechnicalDetailChemicallyResistant = 'TechnicalDetail_ChemicallyResistant',
  TechnicalDetailRestingTime = 'TechnicalDetail_RestingTime',
  TechnicalDetailPotLife = 'TechnicalDetail_PotLife',
  TechnicalDetailProcessingTime = 'TechnicalDetail_ProcessingTime',
  TechnicalDetailOpenTime = 'TechnicalDetail_OpenTime',
  TechnicalDetailSkinImageTime = 'TechnicalDetail_SkinImageTime',
  TechnicalDetailCorrectability = 'TechnicalDetail_Correctability',
  TechnicalDetailDryingTimeAfterFirstApplication = 'TechnicalDetail_DryingTimeAfterFirstApplication',
  TechnicalDetailDryingTime = 'TechnicalDetail_DryingTime',
  TechnicalDetailCuring = 'TechnicalDetail_Curing',
  TechnicalDetailRevisability = 'TechnicalDetail_Revisability',
  TechnicalDetailAccessibilityForNextWorkStep = 'TechnicalDetail_AccessibilityForNextWorkStep',
  TechnicalDetailAccessibility = 'TechnicalDetail_Accessibility',
  TechnicalDetailGrouting = 'TechnicalDetail_Grouting',
  TechnicalDetailFullyLoadable = 'TechnicalDetail_FullyLoadable',
  TechnicalDetailDryingSpeed = 'TechnicalDetail_DryingSpeed',
  TechnicalDetailCertificateTestReportEstablishClass = 'TechnicalDetail_CertificateTestReportEstablishClass',
  TechnicalDetailFlexuralStrength = 'TechnicalDetail_FlexuralStrength',
  TechnicalDetailCompressiveStrength = 'TechnicalDetail_CompressiveStrength',
  TechnicalDetailTensileStrength = 'TechnicalDetail_TensileStrength',
  TechnicalDetailShearStrength = 'TechnicalDetail_ShearStrength',
  TechnicalDetailPeelStrength = 'TechnicalDetail_PeelStrength',
  TechnicalDetailPullOutStrength = 'TechnicalDetail_PullOutStrength',
  TechnicalDetailShoreAHardness = 'TechnicalDetail_ShoreAHardness',
  TechnicalDetailShoreDHardness = 'TechnicalDetail_ShoreDHardness',
  TechnicalDetailShrinkage = 'TechnicalDetail_Shrinkage',
  TechnicalDetailSwellingBehaviour = 'TechnicalDetail_SwellingBehaviour',
  TechnicalDetailSlump = 'TechnicalDetail_Slump',
  TechnicalDetailCrackBridging = 'TechnicalDetail_CrackBridging',
  TechnicalDetailEModule = 'TechnicalDetail_EModule',
  TechnicalDetailElongationAtBreak = 'TechnicalDetail_ElongationAtBreak',
  TechnicalDetailPermanentlyExpandable = 'TechnicalDetail_PermanentlyExpandable',
  TechnicalDetailLinearDeformation = 'TechnicalDetail_LinearDeformation',
  TechnicalDetailPermissibleDeformation = 'TechnicalDetail_PermissibleDeformation',
  TechnicalDetailWaterPressureResistance = 'TechnicalDetail_WaterPressureResistance',
  TechnicalDetailWaterVapourDiffusionRate = 'TechnicalDetail_WaterVapourDiffusionRate',
  TechnicalDetailWaterVapourPermeability = 'TechnicalDetail_WaterVapourPermeability',
  TechnicalDetailPermeabilityForWater = 'TechnicalDetail_PermeabilityForWater',
  TechnicalDetailCapillaryWaterIntake = 'TechnicalDetail_CapillaryWaterIntake',
  TechnicalDetailUVResistance = 'TechnicalDetail_UVResistance',
  TechnicalDetailCO2Permeability = 'TechnicalDetail_CO2Permeability',
  TechnicalDetailHighCarbonizationResistance = 'TechnicalDetail_HighCarbonizationResistance',
  TechnicalDetailFireClass = 'TechnicalDetail_FireClass',
  TechnicalDetailThermoShockResistance = 'TechnicalDetail_ThermoShockResistance',
  TechnicalDetailTemperatureResistance = 'TechnicalDetail_TemperatureResistance',
  TechnicalDetailHeatResistant = 'TechnicalDetail_HeatResistant',
  TechnicalDetailFlamePoint = 'TechnicalDetail_FlamePoint',
  TechnicalDetailGlassTransitionTemperature = 'TechnicalDetail_GlassTransitionTemperature',
  TechnicalDetailCoefficientOfThermalExpansion = 'TechnicalDetail_CoefficientOfThermalExpansion',
  TechnicalDetailPenetrationDepth = 'TechnicalDetail_PenetrationDepth',
  TechnicalDetailWetAbrasionClass = 'TechnicalDetail_WetAbrasionClass',
  TechnicalDetailCoveringPower = 'TechnicalDetail_CoveringPower',
  TechnicalDetailGlossLevel = 'TechnicalDetail_GlossLevel',
  TechnicalDetailWhiteness = 'TechnicalDetail_Whiteness',
  TechnicalDetailChemicalResistance = 'TechnicalDetail_ChemicalResistance',
  TechnicalDetailLeakageResistance = 'TechnicalDetail_LeakageResistance',
  TechnicalDetailElectricalResistivity = 'TechnicalDetail_ElectricalResistivity',
  TechnicalDetailObjectAndMaterialWorkingTemperature = 'TechnicalDetail_ObjectAndMaterialWorkingTemperature',
  TechnicalDetailSubstrateTemperature = 'TechnicalDetail_SubstrateTemperature',
  TechnicalDetailWorkingTemperature = 'TechnicalDetail_WorkingTemperature',
  TechnicalDetailPermissibleRelativeAirHumidity = 'TechnicalDetail_PermissibleRelativeAirHumidity',
  TechnicalDetailMaterialThickness = 'TechnicalDetail_MaterialThickness',
  TechnicalDetailDimension = 'TechnicalDetail_Dimension',
  TechnicalDetailWeight = 'TechnicalDetail_Weight',
  TechnicalDetailBasisWeight = 'TechnicalDetail_BasisWeight',
  TechnicalDetailExtraAttribute1 = 'TechnicalDetail_ExtraAttribute1',
  TechnicalDetailExtraTextAttribute1 = 'TechnicalDetail_ExtraTextAttribute1',
  TechnicalDetailExtraAttribute2 = 'TechnicalDetail_ExtraAttribute2',
  TechnicalDetailExtraTextAttribute2 = 'TechnicalDetail_ExtraTextAttribute2',
  TechnicalDetailExtraAttribute3 = 'TechnicalDetail_ExtraAttribute3',
  TechnicalDetailExtraTextAttribute3 = 'TechnicalDetail_ExtraTextAttribute3',
  TechnicalDetailExtraAttribute4 = 'TechnicalDetail_ExtraAttribute4',
  TechnicalDetailExtraTextAttribute4 = 'TechnicalDetail_ExtraTextAttribute4',
  TechnicalDetailExtraAttribute5 = 'TechnicalDetail_ExtraAttribute5',
  TechnicalDetailExtraTextAttribute5 = 'TechnicalDetail_ExtraTextAttribute5',
  DescriptionProductTitle = 'Description_ProductTitle',
  DescriptionProductTitleLong = 'Description_ProductTitleLong',
  DescriptionAdvantage1 = 'Description_Advantage1',
  DescriptionAdvantage2 = 'Description_Advantage2',
  DescriptionAdvantage3 = 'Description_Advantage3',
  DescriptionAdvantage4 = 'Description_Advantage4',
  DescriptionAdvantage5 = 'Description_Advantage5',
  DescriptionProductDescriptionShort = 'Description_ProductDescriptionShort',
  StorageDays = 'Storage_Days',
  SealOfApprovalAndNormNorm = 'SealOfApprovalAndNorm_Norm',
  SubstrateRequirementStandard = 'Substrate_RequirementStandard',
  SubstratePreprocessing = 'Substrate_Preprocessing',
  PrepareToolText = 'Prepare_ToolText',
  PrepareMixing = 'Prepare_Mixing',
  PrepareProcess = 'Prepare_Process',
  PrepareProcessingshort = 'Prepare_Processingshort',
  ProductHintStandardText = 'ProductHint_StandardText',
  WorkSafetyInformation = 'WorkSafety_Information',
  PerfectSystemMaterialGroups = 'PerfectSystem_MaterialGroups',
  PerfectSystemSystemProductDescription = 'PerfectSystem_SystemProductDescription',
}

export interface MaterialGroupCountryRequest {
  /** @format int32 */
  materialGroupId?: number;
  countryCodes?: string[] | null;
}

export interface MaterialGroupCountryResponse {
  /** @format int32 */
  materialGroupId?: number;
  countryCodes?: string[] | null;
}

export interface MaterialGroupExportRequest {
  countryCode: string;
  materialGroupIds: number[];
  attributes: MaterialGroupAttributeType[];
  productTypeCodes?: string[] | null;
}

export interface MaterialGroupResponse {
  createdBy?: string | null;

  /** @format date-time */
  createdAt?: string;
  updatedBy?: string | null;

  /** @format date-time */
  updatedAt?: string;
  isActive?: boolean;

  /** @format int32 */
  id?: number;
  materialGroupDescription?: string | null;
  materialGroupName?: string | null;
  materialGroupTitle?: string | null;

  /** @format int32 */
  divisionId?: number;

  /** @format int32 */
  productGroupId?: number;
  countryCode?: string | null;
  erpImport?: boolean;

  /** @format int32 */
  imageStoreMaterialGroupId?: number | null;
  variantCode?: string | null;
  variantName?: string | null;
}

export interface MaterialGroupTreeResponse {
  /** @format int32 */
  id: number;
  name: string;
  description?: string | null;
}

export interface MaterialGroupUpdateRequest {
  materialGroupName?: string | null;
  materialGroupDescription?: string | null;
  productTitle?: string | null;
}

export interface ObjectObjectApplicationAndUserInformation {
  environmentName?: string | null;
  version?: string | null;
  displayVersion?: string | null;
  binaryCreationTimeUtc?: string | null;
  binaryCreationTime?: string | null;
  isAuthenticated?: boolean;
  user?: UserInformation;
  setting?: any;
  options?: any;
}

export interface ObjectObjectTestHttpResponse {
  /** @format int32 */
  statusCode?: number;
  status?: string | null;
  error?: string | null;
  bodyError?: string | null;
  headers?: Record<string, string | null>;
  body?: string | null;
}

export interface ObjectObjectTestPingResult {
  error?: string | null;
  succeeded?: boolean;
  status?: string | null;
  ipAddress?: string | null;

  /** @format int64 */
  roundtripTime?: number;

  /** @format int32 */
  bufferLength?: number | null;

  /** @format int32 */
  timeToLive?: number | null;
  dontFragment?: boolean | null;
  replyAddress?: string | null;
}

export interface ObjectObjectTestTCPResult {
  error?: string | null;
  succeeded?: boolean;
  ipAddress?: string | null;
}

export interface OperatingSystem {
  platform?: PlatformID;
  servicePack?: string | null;
  version?: Version;
  versionString?: string | null;
}

export interface PerfectSystemMaterialGroupRequestModel {
  /** @format int32 */
  materialGroupId?: number;
}

export interface PerfectSystemMaterialGroupResponseModel {
  /** @format int32 */
  materialGroupId?: number;
  materialGroup?: MaterialGroupResponse;
}

export interface PerfectSystemRequestModel {
  /** @format int32 */
  id?: number;
  systemProductDescription?: string | null;
  perfectSystemMaterialGroups?: PerfectSystemMaterialGroupRequestModel[] | null;
}

export interface PerfectSystemResponseModel {
  /** @format int32 */
  id?: number;
  countryCode?: string | null;
  systemProductDescription?: string | null;

  /** @format int32 */
  materialGroupId?: number;
  perfectSystemMaterialGroups?: PerfectSystemMaterialGroupResponseModel[] | null;
}

export interface PictogramImageResponse {
  fileName?: string | null;
  updatedBy?: string | null;

  /** @format date-time */
  updatedAt?: string;
  createdBy?: string | null;

  /** @format date-time */
  createdAt?: string;
}

export interface PictogramRequest {
  fileName?: string | null;
}

export interface PictogramResponse {
  /** @format int32 */
  id?: number;
  fileName?: string | null;
}

export interface PictogramResponseModel {
  createdBy?: string | null;

  /** @format date-time */
  createdAt?: string;
  updatedBy?: string | null;

  /** @format date-time */
  updatedAt?: string;
  isActive?: boolean;
  id: string;
  fileName?: string | null;
  fullName?: string | null;

  /** @format int64 */
  fileSize?: number;
}

export enum PlatformID {
  Win32S = 'Win32S',
  Win32Windows = 'Win32Windows',
  Win32NT = 'Win32NT',
  WinCE = 'WinCE',
  Unix = 'Unix',
  Xbox = 'Xbox',
  MacOSX = 'MacOSX',
  Other = 'Other',
}

export interface PrepareRequestModel {
  /** @format int32 */
  id?: number;
  toolText?: string | null;
  mixing?: string | null;
  process?: string | null;
  processingShort?: string | null;

  /** @format int32 */
  materialGroupId?: number;
}

export interface PrepareResponseModel {
  /** @format int32 */
  id?: number;
  countryCode?: string | null;
  toolText?: string | null;
  mixing?: string | null;
  process?: string | null;
  processingShort?: string | null;

  /** @format int32 */
  materialGroupId?: number;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;

  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
}

export interface ProductCatalogArticleResponse {
  Artikelnummer?: string | null;
  Bezeichnung?: string | null;
  EAN?: string | null;
  GebindeArtNr?: string | null;
  Mengeneinheit?: string | null;

  /** @format double */
  PaletteAnzGebinde?: number | null;
  Produktart?: string | null;
  Deleted?: boolean;
  Laenderzuordnung?: string | null;
  'Verknüpfung Komplex B'?: string | null;
  Preisgruppe?: string | null;
  'V5-Text Spalte 1'?: string | null;
  'V5-Text Spalte 2'?: string | null;
  Farbe?: string | null;

  /** @format double */
  Überverpackung?: number | null;

  /** @format double */
  ME?: number | null;

  /** @format double */
  'Betrag in Buchungswährung'?: number | null;

  /** @format double */
  Kilopreis?: number | null;
}

export interface ProductCatalogAvailableMaterialGroupsResponse {
  /** @format int32 */
  id: number;
  materialGroupName?: string | null;
  materialGroupDescription?: string | null;
  ean?: string | null;
  variant?: string | null;
}

export interface ProductCatalogGroupResponse {
  W?: ProductCatalogMaterialGroupResponse[] | null;
}

export interface ProductCatalogMaterialGroupResponse {
  SpartenBezeichnung?: string | null;
  ProduktgruppenBezeichnung?: string | null;

  /** @format int32 */
  Deleted?: number;
  Bezeichnung?: string | null;
  Code?: string | null;
  refernzPg?: string | null;
  Kurztext?: string | null;
  Vorteil1?: string | null;
  Vorteil2?: string | null;
  Vorteil3?: string | null;
  Vorteil4?: string | null;
  Vorteil5?: string | null;
  Neuprodukt?: boolean;
  AnzeigeBild?: ExportFileDataResponse;
  Verbrauch?: string | null;
  Farbe?: string | null;
  Systemprodukte?: string[] | null;
  SysProdBeschreibung?: string | null;
  Aktiv?: boolean;
  Artikel?: ProductCatalogArticleResponse[] | null;
  Piktogramme?: ExportFileDataResponse[] | null;
  Pruefzeichen?: ExportFileDataResponse[] | null;
  TechMerkblaetter?: ExportFileDataResponse[] | null;
  Sicherheitsdatenblaetter?: ExportFileDataResponse[] | null;
  Infoblaetter?: ExportFileDataResponse[] | null;
  Drucksorten?: ExportFileDataResponse[] | null;
  Leistungserklaerungen?: ExportFileDataResponse[] | null;
  Umweltproduktdeklarationen?: ExportFileDataResponse[] | null;
  Sparte_Code?: string | null;
  Sparte_Landerkennung?: string | null;

  /** @format int32 */
  Sparte_Reihenfolge?: number;
  Sparte_Spartenfarbe?: string | null;
  Sparte_Logotitel?: string | null;
  Produktgruppe_Code?: string | null;
  Sparte_Techmerkblaetter?: ExportFileDataResponse[] | null;
  Sparte_Sicherheitsdatenblaetter?: ExportFileDataResponse[] | null;
  Sparte_Infoblaetter?: ExportFileDataResponse[] | null;
  Sparte_Drucksorten?: ExportFileDataResponse[] | null;
  Sparte_Leistungserklaerungen?: ExportFileDataResponse[] | null;
}

export interface ProductCatalogResponse {
  /** @format int32 */
  id: number;
  materialGroupName?: string | null;
  materialGroupDescription?: string | null;
  variant?: string | null;

  /** @format int32 */
  order?: number;
  isMaterialGroupActive?: boolean;
}

export interface ProductCatalogSaveRequest {
  productCatalogSaveRequestItems?: ProductCatalogSaveRequestItem[] | null;
}

export interface ProductCatalogSaveRequestItem {
  /** @format int32 */
  materialGroupId: number;

  /** @format int32 */
  divisionId: number;
  countryCode: string;
}

export interface ProductGroupCountryRequest {
  /** @format int32 */
  productGroupId?: number;
  productGroupCountryDescription?: string | null;
}

export interface ProductGroupCreateRequest {
  /** @format int32 */
  divisionId?: number;
  productGroupName?: string | null;
  productGroupDescription?: string | null;
}

export interface ProductGroupResponse {
  /** @format int32 */
  id: number;
  productGroupName?: string | null;
  productGroupDescription?: string | null;
  productGroupCountryDescription?: string | null;
  countryCode?: string | null;
}

export interface ProductGroupTreeResponse {
  /** @format int32 */
  id: number;
  name: string;
  description?: string | null;
  materialGroups: MaterialGroupTreeResponse[];
}

export interface ProductGroupUpdateRequest {
  productGroupName?: string | null;
  productGroupDescription?: string | null;
  productGroupCountryDescription?: string | null;
}

export interface ProductHintMaterialGroupRequest {
  /** @format int32 */
  id?: number;
  standardTxt?: string | null;
}

export interface ProductHintMaterialGroupResponse {
  /** @format int32 */
  id?: number;
  standardTxt?: string | null;

  /** @format int32 */
  materialGroupId?: number;
  countryCode?: string | null;
}

export interface ProductHintRequest {
  /** @format int32 */
  id?: number;
  title?: string | null;
  content?: string | null;
}

export interface ProductHintResponse {
  /** @format int32 */
  id?: number;
  title?: string | null;
  content?: string | null;
}

export interface ProductTypeDTO {
  code?: string | null;
  name?: string | null;
}

export interface ProductTypeResponse {
  code?: string | null;
  name?: string | null;
}

export interface QuickLinkRequest {
  title?: string | null;
  path?: string | null;
  breadCrumbs?: string | null;
}

export interface QuickLinkResponse {
  /** @format int32 */
  id?: number;
  userName?: string | null;
  title?: string | null;
  path?: string | null;
  breadCrumbs?: string | null;
}

export interface SealOfApprovalAndNormMaterialGroupRequest {
  /** @format int32 */
  id?: number;
  countryCode?: string | null;

  /** @format int32 */
  materialGroupId?: number;
  norm?: string | null;
  sealOfApprovals?: SealOfApprovalRequest[] | null;
}

export interface SealOfApprovalAndNormMaterialGroupResponse {
  /** @format int32 */
  id?: number;
  country?: string | null;

  /** @format int32 */
  materialGroupId?: number;
  norm?: string | null;
  sealOfApprovals?: SealOfApprovalResponse[] | null;
}

export interface SealOfApprovalImageResponse {
  id: string;
  category?: CategoryResponse;
  fileName?: string | null;
  fullName?: string | null;

  /** @format int64 */
  fileSize?: number;

  /** @format date-time */
  createdAt?: string;
  createdBy?: string | null;

  /** @format date-time */
  updatedAt?: string;
  updatedBy?: string | null;
}

export interface SealOfApprovalRequest {
  fullName: string;
}

export interface SealOfApprovalResponse {
  fullName: string;
}

export interface SearchMaterialGroupResponse {
  createdBy?: string | null;

  /** @format date-time */
  createdAt?: string;
  updatedBy?: string | null;

  /** @format date-time */
  updatedAt?: string;
  isActive?: boolean;

  /** @format int32 */
  id?: number;
  materialGroupDescription?: string | null;
  materialGroupName?: string | null;
  materialGroupTitle?: string | null;

  /** @format int32 */
  productGroupId?: number;
  productName?: string | null;

  /** @format int32 */
  imageStoreMaterialGroupId?: number | null;
}

export interface SearchResponse {
  countryCode: string;
  countryName: string;

  /** @format int32 */
  materialGroupId: number;
  materialGroupDescription: string;
  materialGroupName: string;
  materialGroupTitle?: string | null;

  /** @format int32 */
  productGroupId: number;

  /** @format int32 */
  divisionId: number;

  /** @format int32 */
  articleId?: number | null;
  articleNumber?: string | null;
  articleDescription?: string | null;
  ean?: string | null;
}

export interface StorageRequest {
  storageType?: StorageType;

  /** @format int32 */
  days?: number;
}

export interface StorageResponse {
  /** @format int32 */
  id?: number;
  storageType?: StorageType;

  /** @format int32 */
  days?: number;

  /** @format int32 */
  materialGroupId?: number;
}

export enum StorageType {
  Limited = 'Limited',
  Unlimited = 'Unlimited',
}

export interface SubstrateMaterialGroupRequest {
  /** @format int32 */
  id?: number;
  requirementStandard?: string | null;
  preprocessing?: string | null;
}

export interface SubstrateMaterialGroupResponse {
  /** @format int32 */
  id?: number;
  requirementStandard?: string | null;
  preprocessing?: string | null;

  /** @format int32 */
  materialGroupId?: number;
  countryCode?: string | null;
}

export interface SubstrateRequest {
  /** @format int32 */
  id?: number;
  title?: string | null;
  content?: string | null;
}

export interface SubstrateResponse {
  /** @format int32 */
  id?: number;
  countryCode?: string | null;
  title?: string | null;
  content?: string | null;
}

export interface TechnicalDatasheetAttachmentResponse {
  /** @format int32 */
  id?: number;
  fileName?: string | null;

  /** @format date-time */
  createdAt?: string;
}

export interface TechnicalDetailsRequestModel {
  /** @format int32 */
  id?: number;
  chemicalBase?: string | null;
  dense?: string | null;
  bulkDensity?: string | null;
  freshMortarDensity?: string | null;
  largestGrain?: string | null;
  solidStateContent?: string | null;
  viscosity?: string | null;
  µValue?: string | null;
  sdValue?: string | null;
  phValue?: string | null;
  appearance?: string | null;
  color?: string | null;
  gloss?: string | null;
  consumption?: string | null;
  productiveness?: string | null;
  waterDemand?: string | null;
  mixingRatio?: string | null;
  dilution?: string | null;
  layerThickness?: string | null;
  jointWidth?: string | null;
  dryFilmThickness?: string | null;
  ventilationTime?: string | null;
  insertionTime?: string | null;
  readyForPublishing?: string | null;
  rainproof?: string | null;
  finalStrength?: string | null;
  grindability?: string | null;
  mechanicallyResilient?: string | null;
  chemicallyResistant?: string | null;
  restingTime?: string | null;
  potLife?: string | null;
  processingTime?: string | null;
  openTime?: string | null;
  skinImageTime?: string | null;
  correctability?: string | null;
  dryingTimeAfterFirstApplication?: string | null;
  dryingTime?: string | null;
  curing?: string | null;
  revisability?: string | null;
  accessibilityForNextWorkStep?: string | null;
  accessibility?: string | null;
  grouting?: string | null;
  fullyLoadable?: string | null;
  dryingSpeed?: string | null;
  certificateTestReportEstablishClass?: string | null;
  flexuralStrength?: string | null;
  compressiveStrength?: string | null;
  tensileStrength?: string | null;
  shearStrength?: string | null;
  peelStrength?: string | null;
  pullOutStrength?: string | null;
  shoreAHardness?: string | null;
  shoreDHardness?: string | null;
  shrinkage?: string | null;
  swellingBehaviour?: string | null;
  slump?: string | null;
  crackBridging?: string | null;
  eModule?: string | null;
  elongationAtBreak?: string | null;
  permanentlyExpandable?: string | null;
  linearDeformation?: string | null;
  permissibleDeformation?: string | null;
  waterPressureResistance?: string | null;
  waterVapourDiffusionRate?: string | null;
  waterVapourPermeability?: string | null;
  permeabilityForWater?: string | null;
  capillaryWaterIntake?: string | null;
  uvResistance?: string | null;
  cO2Permeability?: string | null;
  highCarbonizationResistance?: string | null;
  fireClass?: string | null;
  thermoShockResistance?: string | null;
  temperatureResistance?: string | null;
  heatResistant?: string | null;
  flamePoint?: string | null;
  glassTransitionTemperature?: string | null;
  coefficientOfThermalExpansion?: string | null;
  penetrationDepth?: string | null;
  wetAbrasionClass?: string | null;
  coveringPower?: string | null;
  glossLevel?: string | null;
  whiteness?: string | null;
  chemicalResistance?: string | null;
  leakageResistance?: string | null;
  electricalResistivity?: string | null;
  objectAndMaterialWorkingTemperature?: string | null;
  substrateTemperature?: string | null;
  workingTemperature?: string | null;
  permissibleRelativeAirHumidity?: string | null;
  materialThickness?: string | null;
  dimension?: string | null;
  weight?: string | null;
  basisWeight?: string | null;
  extraAttribute1?: string | null;
  extraAttribute2?: string | null;
  extraAttribute3?: string | null;
  extraAttribute4?: string | null;
  extraAttribute5?: string | null;
  extraTextAttribute1?: string | null;
  extraTextAttribute2?: string | null;
  extraTextAttribute3?: string | null;
  extraTextAttribute4?: string | null;
  extraTextAttribute5?: string | null;
}

export interface TechnicalDetailsResponseModel {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  materialGroupId?: number;
  countryCode?: string | null;
  chemicalBase?: string | null;
  dense?: string | null;
  bulkDensity?: string | null;
  freshMortarDensity?: string | null;
  largestGrain?: string | null;
  solidStateContent?: string | null;
  viscosity?: string | null;
  µValue?: string | null;
  sdValue?: string | null;
  phValue?: string | null;
  appearance?: string | null;
  color?: string | null;
  gloss?: string | null;
  consumption?: string | null;
  productiveness?: string | null;
  waterDemand?: string | null;
  mixingRatio?: string | null;
  dilution?: string | null;
  layerThickness?: string | null;
  jointWidth?: string | null;
  dryFilmThickness?: string | null;
  ventilationTime?: string | null;
  insertionTime?: string | null;
  readyForPublishing?: string | null;
  rainproof?: string | null;
  finalStrength?: string | null;
  grindability?: string | null;
  mechanicallyResilient?: string | null;
  chemicallyResistant?: string | null;
  restingTime?: string | null;
  potLife?: string | null;
  processingTime?: string | null;
  openTime?: string | null;
  skinImageTime?: string | null;
  correctability?: string | null;
  dryingTimeAfterFirstApplication?: string | null;
  dryingTime?: string | null;
  curing?: string | null;
  revisability?: string | null;
  accessibilityForNextWorkStep?: string | null;
  accessibility?: string | null;
  grouting?: string | null;
  fullyLoadable?: string | null;
  dryingSpeed?: string | null;
  certificateTestReportEstablishClass?: string | null;
  flexuralStrength?: string | null;
  compressiveStrength?: string | null;
  tensileStrength?: string | null;
  shearStrength?: string | null;
  peelStrength?: string | null;
  pullOutStrength?: string | null;
  shoreAHardness?: string | null;
  shoreDHardness?: string | null;
  shrinkage?: string | null;
  swellingBehaviour?: string | null;
  slump?: string | null;
  crackBridging?: string | null;
  eModule?: string | null;
  elongationAtBreak?: string | null;
  permanentlyExpandable?: string | null;
  linearDeformation?: string | null;
  permissibleDeformation?: string | null;
  waterPressureResistance?: string | null;
  waterVapourDiffusionRate?: string | null;
  waterVapourPermeability?: string | null;
  permeabilityForWater?: string | null;
  capillaryWaterIntake?: string | null;
  uvResistance?: string | null;
  cO2Permeability?: string | null;
  highCarbonizationResistance?: string | null;
  fireClass?: string | null;
  thermoShockResistance?: string | null;
  temperatureResistance?: string | null;
  heatResistant?: string | null;
  flamePoint?: string | null;
  glassTransitionTemperature?: string | null;
  coefficientOfThermalExpansion?: string | null;
  penetrationDepth?: string | null;
  wetAbrasionClass?: string | null;
  coveringPower?: string | null;
  glossLevel?: string | null;
  whiteness?: string | null;
  chemicalResistance?: string | null;
  leakageResistance?: string | null;
  electricalResistivity?: string | null;
  objectAndMaterialWorkingTemperature?: string | null;
  substrateTemperature?: string | null;
  workingTemperature?: string | null;
  permissibleRelativeAirHumidity?: string | null;
  materialThickness?: string | null;
  dimension?: string | null;
  weight?: string | null;
  basisWeight?: string | null;
  extraAttribute1?: string | null;
  extraAttribute2?: string | null;
  extraAttribute3?: string | null;
  extraAttribute4?: string | null;
  extraAttribute5?: string | null;
  extraTextAttribute1?: string | null;
  extraTextAttribute2?: string | null;
  extraTextAttribute3?: string | null;
  extraTextAttribute4?: string | null;
  extraTextAttribute5?: string | null;
}

export interface TranslationDictionary {
  cultureCode: string;
  texts: Record<string, Record<string, string>>;
}

export interface UpdateDocumentRequest {
  category: DocumentCategory;
  isExported: boolean;
  isKpExported: boolean;
}

export interface UpdateMailRequest {
  /** @format int32 */
  id?: number;
  countryCode?: string | null;
  eMail?: string | null;
}

export interface UserInformation {
  isAuthenticated?: boolean;
  userId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
  email?: string | null;
}

export interface UserPermissionsResponse {
  roleName: string;
  globalPermissions: GlobalPermission[];
  countryPermissionsGroups: CountryPermissionsGroupResponse[];
}

export interface VariantDTO {
  code?: string | null;
  name?: string | null;

  /** @format int32 */
  order?: number;
}

export interface Version {
  /** @format int32 */
  major?: number;

  /** @format int32 */
  minor?: number;

  /** @format int32 */
  build?: number;

  /** @format int32 */
  revision?: number;

  /** @format int32 */
  majorRevision?: number;

  /** @format int32 */
  minorRevision?: number;
}

export interface WebsiteArticleResponse {
  Artikelnummer?: string | null;
  Bezeichnung?: string | null;
  EAN?: string | null;
  GebindeArtNr?: string | null;
  Mengeneinheit?: string | null;

  /** @format double */
  PaletteAnzGebinde?: number | null;
  Produktart?: string | null;
  Deleted?: boolean;
  Laenderzuordnung?: string | null;
  'Verknüpfung Komplex B'?: string | null;
  Preisgruppe?: string | null;
  'V5-Text Spalte 1'?: string | null;
  'V5-Text Spalte 2'?: string | null;
  Farbe?: string | null;

  /** @format double */
  Überverpackung?: number | null;

  /** @format double */
  ME?: number | null;
}

export interface WebsiteGroupResponse {
  W?: WebsiteMaterialGroupResponse[] | null;
}

export interface WebsiteMaterialGroupResponse {
  SpartenBezeichnung?: string | null;
  ProduktgruppenBezeichnung?: string | null;

  /** @format int32 */
  Deleted?: number;
  Bezeichnung?: string | null;
  Code?: string | null;
  refernzPg?: string | null;
  Kurztext?: string | null;
  Vorteil1?: string | null;
  Vorteil2?: string | null;
  Vorteil3?: string | null;
  Vorteil4?: string | null;
  Vorteil5?: string | null;
  Neuprodukt?: boolean;
  AnzeigeBild?: ExportFileDataResponse;
  Verbrauch?: string | null;
  Farbe?: string | null;
  Systemprodukte?: string[] | null;
  SysProdBeschreibung?: string | null;
  Aktiv?: boolean;
  Artikel?: WebsiteArticleResponse[] | null;
  Piktogramme?: ExportFileDataResponse[] | null;
  Pruefzeichen?: ExportFileDataResponse[] | null;
  TechMerkblaetter?: ExportFileDataResponse[] | null;
  Sicherheitsdatenblaetter?: ExportFileDataResponse[] | null;
  Infoblaetter?: ExportFileDataResponse[] | null;
  Drucksorten?: ExportFileDataResponse[] | null;
  Leistungserklaerungen?: ExportFileDataResponse[] | null;
  Umweltproduktdeklarationen?: ExportFileDataResponse[] | null;
  Sparte_Code?: string | null;
  Sparte_Landerkennung?: string | null;

  /** @format int32 */
  Sparte_Reihenfolge?: number;
  Sparte_Spartenfarbe?: string | null;
  Sparte_Logotitel?: string | null;
  Produktgruppe_Code?: string | null;
  Sparte_Techmerkblaetter?: ExportFileDataResponse[] | null;
  Sparte_Sicherheitsdatenblaetter?: ExportFileDataResponse[] | null;
  Sparte_Infoblaetter?: ExportFileDataResponse[] | null;
  Sparte_Drucksorten?: ExportFileDataResponse[] | null;
  Sparte_Leistungserklaerungen?: ExportFileDataResponse[] | null;
}

export interface WorksafetyRequestModel {
  /** @format int32 */
  id?: number;
  workSafetyInformation?: string | null;

  /** @format int32 */
  materialGroupId?: number;
}

export interface WorksafetyResponseModel {
  /** @format int32 */
  id?: number;
  countryCode?: string | null;
  workSafetyInformation?: string | null;

  /** @format int32 */
  materialGroupId?: number;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];

        if (property instanceof Array && property.every((item) => item instanceof Blob)) {
          for (let file of property) {
            formData.append(key, file);
          }
        } else {
          formData.append(
            key,
            property instanceof Blob
              ? property
              : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : property !== null && property !== undefined
              ? `${property}`
              : ''
          );
        }
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Murexin.PIM.Web
 * @version 1.16.0.0
 */
export class MurexinPimContextApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags ApiKey
   * @name GenerateCreate
   * @request POST:/generate
   */
  generateCreate = (query?: { name?: string }, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/generate`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ApplicationController`2
   * @name DccsAspNetCoreApplicationController
   * @request GET:/application
   */

  dccsAspNetCoreApplicationController = (params: RequestParams = {}) =>
    this.request<ObjectObjectApplicationAndUserInformation, any>({
      path: `/application`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  cookieTest = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name CookieTestList
     * @request GET:/application/cookieTest
     */
    cookieTestList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/cookieTest`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  serverTimeUtc = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name ServerTimeUtcList
     * @request GET:/application/serverTimeUtc
     */
    serverTimeUtcList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/serverTimeUtc`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  serverTime = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name ServerTimeList
     * @request GET:/application/serverTime
     */
    serverTimeList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/serverTime`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  startTimeUtc = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name StartTimeUtcList
     * @request GET:/application/startTimeUtc
     */
    startTimeUtcList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/startTimeUtc`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  startTime = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name StartTimeList
     * @request GET:/application/startTime
     */
    startTimeList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/startTime`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  runningTime = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name RunningTimeList
     * @request GET:/application/runningTime
     */
    runningTimeList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/runningTime`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  uniqueInstanceId = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name UniqueInstanceIdList
     * @request GET:/application/uniqueInstanceId
     */
    uniqueInstanceIdList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/uniqueInstanceId`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  environmentName = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name EnvironmentNameList
     * @request GET:/application/environmentName
     */
    environmentNameList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/environmentName`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  version = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name VersionList
     * @request GET:/application/version
     */
    versionList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/version`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  binaryCreationTime = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name BinaryCreationTimeList
     * @request GET:/application/binaryCreationTime
     */
    binaryCreationTimeList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/binaryCreationTime`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  binaryCreationTimeUtc = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name BinaryCreationTimeUtcList
     * @request GET:/application/binaryCreationTimeUtc
     */
    binaryCreationTimeUtcList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/binaryCreationTimeUtc`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  displayVersion = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name DisplayVersionList
     * @request GET:/application/displayVersion
     */
    displayVersionList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/application/displayVersion`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  isAuthenticated = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name IsAuthenticatedList
     * @request GET:/application/isAuthenticated
     */
    isAuthenticatedList: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/application/isAuthenticated`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  checkUser = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name CheckUserList
     * @request GET:/application/checkUser
     */
    checkUserList: (params: RequestParams = {}) =>
      this.request<UserInformation, any>({
        path: `/application/checkUser`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  options = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name OptionsList
     * @request GET:/application/options
     */
    optionsList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/application/options`,
        method: 'GET',
        ...params,
      }),
  };
  settings = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name SettingsList
     * @request GET:/application/settings
     */
    settingsList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/application/settings`,
        method: 'GET',
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name UserList
     * @request GET:/application/user
     */
    userList: (params: RequestParams = {}) =>
      this.request<UserInformation, any>({
        path: `/application/user`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags User
     * @name UserPermissionsList
     * @request GET:/api/User/Permissions
     */,

    userPermissionsList: (params: RequestParams = {}) =>
      this.request<UserPermissionsResponse, any>({
        path: `/api/User/Permissions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  testhttp = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name TesthttpDetail
     * @request GET:/application/testhttp/{url}
     */
    testhttpDetail: (url: string, params: RequestParams = {}) =>
      this.request<ObjectObjectTestHttpResponse, any>({
        path: `/application/testhttp/${url}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  testhttps = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name TesthttpsDetail
     * @request GET:/application/testhttps/{url}
     */
    testhttpsDetail: (url: string, params: RequestParams = {}) =>
      this.request<ObjectObjectTestHttpResponse, any>({
        path: `/application/testhttps/${url}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  testTcp = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name TestTcpDetail
     * @request GET:/application/testTCP/{hostOrIpAndPort}
     */
    testTcpDetail: (hostOrIpAndPort: string, params: RequestParams = {}) =>
      this.request<ObjectObjectTestTCPResult, any>({
        path: `/application/testTCP/${hostOrIpAndPort}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  ping = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name PingDetail
     * @request GET:/application/ping/{host}
     */
    pingDetail: (host: string, params: RequestParams = {}) =>
      this.request<ObjectObjectTestPingResult, any>({
        path: `/application/ping/${host}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  diagnostic = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name DiagnosticList
     * @request GET:/application/diagnostic
     */
    diagnosticList: (params: RequestParams = {}) =>
      this.request<DiagnosticInformation, any>({
        path: `/application/diagnostic`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  applicationDataJs = {
    /**
     * No description
     *
     * @tags ApplicationController`2
     * @name ApplicationDataJsList
     * @request GET:/application/applicationData.js
     */
    applicationDataJsList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/application/applicationData.js`,
        method: 'GET',
        ...params,
      }),
  };
  articleService = {
    /**
     * No description
     *
     * @tags ArticleService
     * @name ArticleServiceArticleDetail
     * @request GET:/api/ArticleService/{country}/article/{articleId}
     */
    articleServiceArticleDetail: (country: string, articleId: number, params: RequestParams = {}) =>
      this.request<ArticleResponse, ProblemDetails>({
        path: `/api/ArticleService/${country}/article/${articleId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ArticleService
     * @name ArticleServiceArticleCreate
     * @request POST:/api/ArticleService/{country}/article/{articleId}
     */,

    articleServiceArticleCreate: (
      country: string,
      articleId: number,
      data: {
        ArticleId?: number;
        MaterialGroupId?: number;
        ArticleDescription?: string;
        ArticleNumber?: string;
        EAN?: string;
        ContainerType?: string;
        ProductTypeCode?: string;
        PalletNumberOfContainers?: number;
        OverCartonNumberOfContainers?: number;
        ArticleCountryNumber?: string;
        IsGlobal?: boolean;
        ArticleNumberComplexB?: string;
        PriceGroup?: string;
        V5TextColumn1?: string;
        V5TextColumn2?: string;
        Color?: string;
        AddedArrangementLayoutFiles?: File[];
      },
      query?: { DeletedArrangementLayoutIds?: number[] },
      params: RequestParams = {}
    ) =>
      this.request<ArticleResponse, ProblemDetails>({
        path: `/api/ArticleService/${country}/article/${articleId}`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ArticleService
     * @name ArticleServiceArticleDelete
     * @request DELETE:/api/ArticleService/{country}/article/{articleId}
     */,

    articleServiceArticleDelete: (country: string, articleId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/ArticleService/${country}/article/${articleId}`,
        method: 'DELETE',
        ...params,
      })
    /**
     * No description
     *
     * @tags ArticleService
     * @name ArticleServiceArticleListMaterialGroupDetail
     * @request GET:/api/ArticleService/{country}/articleList/materialGroup/{materialGroupId}
     */,

    articleServiceArticleListMaterialGroupDetail: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<ArticleResponse[], ProblemDetails>({
        path: `/api/ArticleService/${country}/articleList/materialGroup/${materialGroupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ArticleService
     * @name ArticleServiceArticleCountryCreate
     * @request POST:/api/ArticleService/{country}/articleCountry/{articleId}
     */,

    articleServiceArticleCountryCreate: (
      country: string,
      articleId: number,
      data: {
        ArticleId?: number;
        ArticleDescription?: string;
        ProductTypeCode?: string;
        ArticleCountryNumber?: string;
        AddedArrangementLayoutFiles?: File[];
      },
      query?: { DeletedArrangementLayoutIds?: number[] },
      params: RequestParams = {}
    ) =>
      this.request<ArticleResponse, ProblemDetails>({
        path: `/api/ArticleService/${country}/articleCountry/${articleId}`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ArticleService
     * @name ArticleServiceErpArticleCreate
     * @request POST:/api/ArticleService/{country}/ERPArticle/{articleId}
     */,

    articleServiceErpArticleCreate: (
      country: string,
      articleId: number,
      data: {
        ArticleId?: number;
        ArticleCountryNumber?: string;
        AddedArrangementLayoutFiles?: File[];
        IsGlobal?: boolean;
        ArticleNumberComplexB?: string;
        PriceGroup?: string;
        V5TextColumn1?: string;
        V5TextColumn2?: string;
        Color?: string;
      },
      query?: { DeletedArrangementLayoutIds?: number[] },
      params: RequestParams = {}
    ) =>
      this.request<ArticleResponse, ProblemDetails>({
        path: `/api/ArticleService/${country}/ERPArticle/${articleId}`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ArticleService
     * @name ArticleServiceProductTypesDetail
     * @request GET:/api/ArticleService/{country}/productTypes
     */,

    articleServiceProductTypesDetail: (country: string, params: RequestParams = {}) =>
      this.request<ProductTypeDTO[], any>({
        path: `/api/ArticleService/${country}/productTypes`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ArticleService
     * @name ArticleServiceArrangementLayoutDetail
     * @request GET:/api/ArticleService/{country}/arrangementLayout/{layoutId}
     */,

    articleServiceArrangementLayoutDetail: (country: string, layoutId: number, params: RequestParams = {}) =>
      this.request<File, ProblemDetails>({
        path: `/api/ArticleService/${country}/arrangementLayout/${layoutId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  category = {
    /**
     * No description
     *
     * @tags Category
     * @name CategoryList
     * @request GET:/api/Category
     */
    categoryList: (params: RequestParams = {}) =>
      this.request<CategoryResponse[], any>({
        path: `/api/Category`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  comment = {
    /**
     * No description
     *
     * @tags Comment
     * @name CommentCreate
     * @request POST:/api/Comment/{country}
     */
    commentCreate: (country: string, data: CommentRequest, params: RequestParams = {}) =>
      this.request<CommentResponse, any>({
        path: `/api/Comment/${country}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Comment
     * @name CommentByMaterialIdDetail
     * @request GET:/api/Comment/{country}/ByMaterialId/{materialGroupId}
     */,

    commentByMaterialIdDetail: (materialGroupId: number, country: string, params: RequestParams = {}) =>
      this.request<CommentResponse[], any>({
        path: `/api/Comment/${country}/ByMaterialId/${materialGroupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Comment
     * @name CommentDeactivateUpdate
     * @request PUT:/api/Comment/{country}/{commentId}/deactivate
     */,

    commentDeactivateUpdate: (commentId: number, country: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/Comment/${country}/${commentId}/deactivate`,
        method: 'PUT',
        ...params,
      }),
  };
  admin = {
    /**
     * No description
     *
     * @tags ContainerLayoutExport
     * @name AdminContainerLayoutExportMaterialGroupsList
     * @request GET:/api/admin/ContainerLayoutExport/MaterialGroups
     */
    adminContainerLayoutExportMaterialGroupsList: (params: RequestParams = {}) =>
      this.request<AdminMaterialGroupResponse[], any>({
        path: `/api/admin/ContainerLayoutExport/MaterialGroups`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ContainerLayoutExport
     * @name AdminContainerLayoutExportProductGroupsList
     * @request GET:/api/admin/ContainerLayoutExport/ProductGroups
     */,

    adminContainerLayoutExportProductGroupsList: (params: RequestParams = {}) =>
      this.request<AdminProductGroupResponse[], any>({
        path: `/api/admin/ContainerLayoutExport/ProductGroups`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ContainerLayoutExport
     * @name AdminContainerLayoutExportExportFileDetail
     * @request GET:/api/admin/ContainerLayoutExport/export/{materialGroupId}/file
     */,

    adminContainerLayoutExportExportFileDetail: (
      materialGroupId: number,
      query?: { fileName?: string },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/admin/ContainerLayoutExport/export/${materialGroupId}/file`,
        method: 'GET',
        query: query,
        ...params,
      })
    /**
     * No description
     *
     * @tags DocumentAdmin
     * @name AdminDocumentAdminList
     * @request GET:/api/admin/DocumentAdmin
     */,

    adminDocumentAdminList: (params: RequestParams = {}) =>
      this.request<AdminDocumentResponse[], any>({
        path: `/api/admin/DocumentAdmin`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DocumentAdmin
     * @name AdminDocumentAdminCreate
     * @request POST:/api/admin/DocumentAdmin
     */,

    adminDocumentAdminCreate: (data: { files?: File[]; documentRequestsJson?: string }, params: RequestParams = {}) =>
      this.request<void, ProblemDetails | void>({
        path: `/api/admin/DocumentAdmin`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      })
    /**
     * No description
     *
     * @tags DocumentAdmin
     * @name AdminDocumentAdminUpdate
     * @request PUT:/api/admin/DocumentAdmin
     */,

    adminDocumentAdminUpdate: (data: AdminUpdateDocumentRequest, params: RequestParams = {}) =>
      this.request<void, ProblemDetails | void>({
        path: `/api/admin/DocumentAdmin`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      })
    /**
     * No description
     *
     * @tags DocumentAdmin
     * @name AdminDocumentAdminDetailsList
     * @request GET:/api/admin/DocumentAdmin/details
     */,

    adminDocumentAdminDetailsList: (params: RequestParams = {}) =>
      this.request<DocumentDetailOptionResponse[], any>({
        path: `/api/admin/DocumentAdmin/details`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DocumentAdmin
     * @name AdminDocumentAdminFileDetail
     * @request GET:/api/admin/DocumentAdmin/{documentId}/file
     */,

    adminDocumentAdminFileDetail: (documentId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/admin/DocumentAdmin/${documentId}/file`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags DocumentAdmin
     * @name AdminDocumentAdminMatchesCreate
     * @request POST:/api/admin/DocumentAdmin/matches
     */,

    adminDocumentAdminMatchesCreate: (data: AdminDocumentMatchRequest[], params: RequestParams = {}) =>
      this.request<AdminDocumentResponse[], any>({
        path: `/api/admin/DocumentAdmin/matches`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DocumentAdmin
     * @name AdminDocumentAdminDelete
     * @request DELETE:/api/admin/DocumentAdmin/{documentId}
     */,

    adminDocumentAdminDelete: (documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails | void>({
        path: `/api/admin/DocumentAdmin/${documentId}`,
        method: 'DELETE',
        ...params,
      })
    /**
     * No description
     *
     * @tags DynamicExport
     * @name AdminDynamicExportMaterialGroupAttributeList
     * @request GET:/api/admin/DynamicExport/materialGroupAttribute
     */,

    adminDynamicExportMaterialGroupAttributeList: (params: RequestParams = {}) =>
      this.request<MaterialGroupAttributeResponse[], any>({
        path: `/api/admin/DynamicExport/materialGroupAttribute`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DynamicExport
     * @name AdminDynamicExportDivisionDetail
     * @request GET:/api/admin/DynamicExport/{country}/division
     */,

    adminDynamicExportDivisionDetail: (country: string, params: RequestParams = {}) =>
      this.request<DivisionTreeResponse[], any>({
        path: `/api/admin/DynamicExport/${country}/division`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DynamicExport
     * @name AdminDynamicExportMaterialGroupFileCreate
     * @request POST:/api/admin/DynamicExport/materialGroupFile
     */,

    adminDynamicExportMaterialGroupFileCreate: (data: MaterialGroupExportRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/admin/DynamicExport/materialGroupFile`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      })
    /**
     * No description
     *
     * @tags DynamicExport
     * @name AdminDynamicExportArticleFileCreate
     * @request POST:/api/admin/DynamicExport/articleFile
     */,

    adminDynamicExportArticleFileCreate: (data: ArticleExportRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/admin/DynamicExport/articleFile`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      })
    /**
     * No description
     *
     * @tags GeneralHint
     * @name AdminGeneralHintList
     * @request GET:/api/admin/GeneralHint
     */,

    adminGeneralHintList: (params: RequestParams = {}) =>
      this.request<GeneralHintResponse[], any>({
        path: `/api/admin/GeneralHint`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags GeneralHint
     * @name AdminGeneralHintUpdate
     * @request PUT:/api/admin/GeneralHint
     */,

    adminGeneralHintUpdate: (data: GeneralHintRequest[], params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/admin/GeneralHint`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags GeneralHint
     * @name AdminGeneralHintDetail
     * @request GET:/api/admin/GeneralHint/{country}
     */,

    adminGeneralHintDetail: (country: string, params: RequestParams = {}) =>
      this.request<GeneralHintResponse, any>({
        path: `/api/admin/GeneralHint/${country}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Import
     * @name AdminImportImportProductCatalogPricesCreate
     * @request POST:/api/admin/Import/ImportProductCatalogPrices
     */,

    adminImportImportProductCatalogPricesCreate: (data: { Year?: number; File?: File }, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/admin/Import/ImportProductCatalogPrices`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductHint
     * @name AdminProductHintList
     * @request GET:/api/admin/ProductHint
     */,

    adminProductHintList: (params: RequestParams = {}) =>
      this.request<ProductHintResponse[], any>({
        path: `/api/admin/ProductHint`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductHint
     * @name AdminProductHintCreate
     * @request POST:/api/admin/ProductHint
     */,

    adminProductHintCreate: (data: ProductHintRequest[], params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/admin/ProductHint`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Substrate
     * @name AdminSubstrateDetail
     * @request GET:/api/admin/Substrate/{country}
     */,

    adminSubstrateDetail: (country: string, params: RequestParams = {}) =>
      this.request<SubstrateResponse[], any>({
        path: `/api/admin/Substrate/${country}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Substrate
     * @name AdminSubstrateUpdate
     * @request PUT:/api/admin/Substrate/{country}
     */,

    adminSubstrateUpdate: (country: string, data: SubstrateRequest[], params: RequestParams = {}) =>
      this.request<SubstrateResponse[], any>({
        path: `/api/admin/Substrate/${country}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  countryService = {
    /**
     * No description
     *
     * @tags CountryService
     * @name CountryServiceList
     * @request GET:/api/CountryService
     */
    countryServiceList: (params: RequestParams = {}) =>
      this.request<CountryResponse[], any>({
        path: `/api/CountryService`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  customerPortalExport = {
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportExportCustomerPortalDetail
     * @request GET:/api/CustomerPortalExport/{country}/exportCustomerPortal
     */
    customerPortalExportExportCustomerPortalDetail: (country: string, params: RequestParams = {}) =>
      this.request<CustomerPortalDivisionResponse[], ProblemDetails | void>({
        path: `/api/CustomerPortalExport/${country}/exportCustomerPortal`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportMaterialGroupImageDetail
     * @request GET:/api/CustomerPortalExport/{country}/materialGroup/{materialId}/image
     */,

    customerPortalExportMaterialGroupImageDetail: (country: string, materialId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/materialGroup/${materialId}/image`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportPictogramImageDetail
     * @request GET:/api/CustomerPortalExport/{country}/pictogram/{pictogramId}/image
     */,

    customerPortalExportPictogramImageDetail: (country: string, pictogramId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/pictogram/${pictogramId}/image`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportSealOfApprovalImageDetail
     * @request GET:/api/CustomerPortalExport/{country}/sealOfApproval/{sealOfApprovalId}/image
     */,

    customerPortalExportSealOfApprovalImageDetail: (
      country: string,
      sealOfApprovalId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/sealOfApproval/${sealOfApprovalId}/image`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportTechnicalDatasheetDetail
     * @request GET:/api/CustomerPortalExport/{country}/technicalDatasheet/{documentId}
     */,

    customerPortalExportTechnicalDatasheetDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/technicalDatasheet/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportSafetyDatasheetDetail
     * @request GET:/api/CustomerPortalExport/{country}/safetyDatasheet/{documentId}
     */,

    customerPortalExportSafetyDatasheetDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/safetyDatasheet/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportInfoSheetDetail
     * @request GET:/api/CustomerPortalExport/{country}/infoSheet/{documentId}
     */,

    customerPortalExportInfoSheetDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/infoSheet/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportPrintingDataDetail
     * @request GET:/api/CustomerPortalExport/{country}/printingData/{documentId}
     */,

    customerPortalExportPrintingDataDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/printingData/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportDeclarationOfPerformanceDetail
     * @request GET:/api/CustomerPortalExport/{country}/declarationOfPerformance/{documentId}
     */,

    customerPortalExportDeclarationOfPerformanceDetail: (
      country: string,
      documentId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/declarationOfPerformance/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportExternalLayoutDetail
     * @request GET:/api/CustomerPortalExport/{country}/externalLayout/{documentId}
     */,

    customerPortalExportExternalLayoutDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/externalLayout/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportTestCertificateDetail
     * @request GET:/api/CustomerPortalExport/{country}/testCertificate/{documentId}
     */,

    customerPortalExportTestCertificateDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/testCertificate/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportDocumentsDetail
     * @request GET:/api/CustomerPortalExport/{country}/documents/{documentId}
     */,

    customerPortalExportDocumentsDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/documents/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportPicturesDetail
     * @request GET:/api/CustomerPortalExport/{country}/pictures/{documentId}
     */,

    customerPortalExportPicturesDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/pictures/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags CustomerPortalExport
     * @name CustomerPortalExportEnvironmentalProductDeclarationDetail
     * @request GET:/api/CustomerPortalExport/{country}/environmentalProductDeclaration/{documentId}
     */,

    customerPortalExportEnvironmentalProductDeclarationDetail: (
      country: string,
      documentId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, ProblemDetails>({
        path: `/api/CustomerPortalExport/${country}/environmentalProductDeclaration/${documentId}`,
        method: 'GET',
        ...params,
      }),
  };
  divisionService = {
    /**
     * No description
     *
     * @tags DivisionService
     * @name DivisionServiceDetail
     * @request GET:/api/DivisionService/{country}
     */
    divisionServiceDetail: (country: string, params: RequestParams = {}) =>
      this.request<DivisionResponseModel[], any>({
        path: `/api/DivisionService/${country}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DivisionService
     * @name DivisionServiceByIdDetail
     * @request GET:/api/DivisionService/{country}/ById/{id}
     */,

    divisionServiceByIdDetail: (id: number, country: string, params: RequestParams = {}) =>
      this.request<DivisionResponseModel, any>({
        path: `/api/DivisionService/${country}/ById/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DivisionService
     * @name DivisionServiceDivisionCountriesDetail
     * @request GET:/api/DivisionService/{country}/divisionCountries
     */,

    divisionServiceDivisionCountriesDetail: (country: string, params: RequestParams = {}) =>
      this.request<DivisionResponseModel[], any>({
        path: `/api/DivisionService/${country}/divisionCountries`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DivisionService
     * @name DivisionServiceGetDivisionCountriesByCountryCodeDetail
     * @request GET:/api/DivisionService/{country}/getDivisionCountriesByCountryCode
     */,

    divisionServiceGetDivisionCountriesByCountryCodeDetail: (country: string, params: RequestParams = {}) =>
      this.request<DivisionCountryResponseModel[], any>({
        path: `/api/DivisionService/${country}/getDivisionCountriesByCountryCode`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DivisionService
     * @name DivisionServiceGetDivisionCountryByIdDetail
     * @request GET:/api/DivisionService/{country}/getDivisionCountryById/{id}
     */,

    divisionServiceGetDivisionCountryByIdDetail: (id: number, country: string, params: RequestParams = {}) =>
      this.request<DivisionCountryResponseModel, any>({
        path: `/api/DivisionService/${country}/getDivisionCountryById/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DivisionService
     * @name DivisionServiceDivisionCountryCreate
     * @request POST:/api/DivisionService/{country}/divisionCountry
     */,

    divisionServiceDivisionCountryCreate: (
      country: string,
      data: DivisionCountryRequestModel,
      params: RequestParams = {}
    ) =>
      this.request<DivisionCountryResponseModel, ProblemDetails>({
        path: `/api/DivisionService/${country}/divisionCountry`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DivisionService
     * @name DivisionServiceDivisionCountryUpdate
     * @request PUT:/api/DivisionService/{country}/divisionCountry/{divisionCountryId}
     */,

    divisionServiceDivisionCountryUpdate: (
      divisionCountryId: number,
      country: string,
      data: DivisionCountryRequestModel,
      params: RequestParams = {}
    ) =>
      this.request<DivisionCountryResponseModel, ProblemDetails>({
        path: `/api/DivisionService/${country}/divisionCountry/${divisionCountryId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags DivisionService
     * @name DivisionServiceBreadCrumbsInfoDetail
     * @request GET:/api/DivisionService/{country}/BreadCrumbsInfo/{id}/{id2}/{id3}
     */,

    divisionServiceBreadCrumbsInfoDetail: (
      country: string,
      id: number,
      id2: number,
      id3: number,
      params: RequestParams = {}
    ) =>
      this.request<BreadCrumbInfoResponseModel[], any>({
        path: `/api/DivisionService/${country}/BreadCrumbsInfo/${id}/${id2}/${id3}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  document = {
    /**
     * No description
     *
     * @tags Document
     * @name DocumentMaterialGroupDetail
     * @request GET:/api/Document/{country}/materialGroup/{materialGroupId}
     */
    documentMaterialGroupDetail: (country: string, materialGroupId: number, params: RequestParams = {}) =>
      this.request<DocumentsGroup[], void>({
        path: `/api/Document/${country}/materialGroup/${materialGroupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Document
     * @name DocumentDivisionDetail
     * @request GET:/api/Document/{country}/division/{divisionId}
     */,

    documentDivisionDetail: (country: string, divisionId: number, params: RequestParams = {}) =>
      this.request<DocumentsGroup[], void>({
        path: `/api/Document/${country}/division/${divisionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Document
     * @name DocumentProductGroupDetail
     * @request GET:/api/Document/{country}/productGroup/{productGroupId}
     */,

    documentProductGroupDetail: (country: string, productGroupId: number, params: RequestParams = {}) =>
      this.request<DocumentsGroup[], void>({
        path: `/api/Document/${country}/productGroup/${productGroupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Document
     * @name DocumentDetail
     * @request GET:/api/Document/{country}/{documentId}
     */,

    documentDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<DocumentResponse, void>({
        path: `/api/Document/${country}/${documentId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Document
     * @name DocumentUpdate
     * @request PUT:/api/Document/{country}/{documentId}
     */,

    documentUpdate: (country: string, documentId: number, data: UpdateDocumentRequest, params: RequestParams = {}) =>
      this.request<void, ProblemDetails | void>({
        path: `/api/Document/${country}/${documentId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      })
    /**
     * No description
     *
     * @tags Document
     * @name DocumentDelete
     * @request DELETE:/api/Document/{country}/{documentId}
     */,

    documentDelete: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails | void>({
        path: `/api/Document/${country}/${documentId}`,
        method: 'DELETE',
        ...params,
      })
    /**
     * No description
     *
     * @tags Document
     * @name DocumentFileDetail
     * @request GET:/api/Document/{country}/{documentId}/file
     */,

    documentFileDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Document/${country}/${documentId}/file`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags Document
     * @name DocumentCreate
     * @request POST:/api/Document/{country}
     */,

    documentCreate: (
      country: string,
      data: {
        Category: DocumentCategory;
        DocumentLevel: DocumentLevel;
        DetailId: number;
        IsExported: boolean;
        IsKpExported: boolean;
        File: File;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, ProblemDetails | void>({
        path: `/api/Document/${country}`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  export = {
    /**
     * No description
     *
     * @tags Export
     * @name ExportExportWebsiteDataDetail
     * @request GET:/api/Export/{country}/exportWebsiteData
     */
    exportExportWebsiteDataDetail: (country: string, params: RequestParams = {}) =>
      this.request<WebsiteGroupResponse[], ProblemDetails | void>({
        path: `/api/Export/${country}/exportWebsiteData`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportSpfastExportWebsiteDataDetail
     * @request GET:/api/Export/{country}/SPFAST/exportWebsiteData
     */,

    exportSpfastExportWebsiteDataDetail: (country: string, params: RequestParams = {}) =>
      this.request<WebsiteGroupResponse[], ProblemDetails | void>({
        path: `/api/Export/${country}/SPFAST/exportWebsiteData`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportExportProductCatalogDataDetail
     * @request GET:/api/Export/{country}/exportProductCatalogData
     */,

    exportExportProductCatalogDataDetail: (country: string, params: RequestParams = {}) =>
      this.request<ProductCatalogGroupResponse[], ProblemDetails | void>({
        path: `/api/Export/${country}/exportProductCatalogData`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportMaterialGroupImageDetail
     * @request GET:/api/Export/{country}/materialGroup/{materialId}/image
     */,

    exportMaterialGroupImageDetail: (country: string, materialId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/Export/${country}/materialGroup/${materialId}/image`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportPictogramImageDetail
     * @request GET:/api/Export/{country}/pictogram/{pictogramId}/image
     */,

    exportPictogramImageDetail: (country: string, pictogramId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/Export/${country}/pictogram/${pictogramId}/image`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportSealOfApprovalImageDetail
     * @request GET:/api/Export/{country}/sealOfApproval/{sealOfApprovalId}/image
     */,

    exportSealOfApprovalImageDetail: (country: string, sealOfApprovalId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/Export/${country}/sealOfApproval/${sealOfApprovalId}/image`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportTechnicalDatasheetDetail
     * @request GET:/api/Export/{country}/technicalDatasheet/{documentId}
     */,

    exportTechnicalDatasheetDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/Export/${country}/technicalDatasheet/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportSafetyDatasheetDetail
     * @request GET:/api/Export/{country}/safetyDatasheet/{documentId}
     */,

    exportSafetyDatasheetDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/Export/${country}/safetyDatasheet/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportInfoSheetDetail
     * @request GET:/api/Export/{country}/infoSheet/{documentId}
     */,

    exportInfoSheetDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/Export/${country}/infoSheet/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportPrintingDataDetail
     * @request GET:/api/Export/{country}/printingData/{documentId}
     */,

    exportPrintingDataDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/Export/${country}/printingData/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportDeclarationOfPerformanceDetail
     * @request GET:/api/Export/{country}/declarationOfPerformance/{documentId}
     */,

    exportDeclarationOfPerformanceDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/Export/${country}/declarationOfPerformance/${documentId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags Export
     * @name ExportEnvironmentalProductDeclarationDetail
     * @request GET:/api/Export/{country}/environmentalProductDeclaration/{documentId}
     */,

    exportEnvironmentalProductDeclarationDetail: (country: string, documentId: number, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/Export/${country}/environmentalProductDeclaration/${documentId}`,
        method: 'GET',
        ...params,
      }),
  };
  materialGroup = {
    /**
     * No description
     *
     * @tags ImageStore
     * @name MaterialGroupImageStoreLoadAllImagesDataDetail
     * @request GET:/api/materialGroup/ImageStore/{country}/loadAllImagesData
     */
    materialGroupImageStoreLoadAllImagesDataDetail: (country: string, params: RequestParams = {}) =>
      this.request<ImageStoreResponse[], any>({
        path: `/api/materialGroup/ImageStore/${country}/loadAllImagesData`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ImageStore
     * @name MaterialGroupImageStoreSaveImageCreate
     * @request POST:/api/materialGroup/ImageStore/{country}/saveImage
     */,

    materialGroupImageStoreSaveImageCreate: (
      country: string,
      data: { FullName?: string; File?: File; FileName?: string; DefaultImage?: boolean; AzureStorageGuid?: string },
      query?: { materialGroupId?: number },
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/materialGroup/ImageStore/${country}/saveImage`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ImageStore
     * @name MaterialGroupImageStoreImageDetail
     * @request GET:/api/materialGroup/ImageStore/{country}/image/{imageStoreMaterialGroupId}
     */,

    materialGroupImageStoreImageDetail: (
      country: string,
      imageStoreMaterialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/materialGroup/ImageStore/${country}/image/${imageStoreMaterialGroupId}`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags ImageStore
     * @name MaterialGroupImageStoreImageDelete
     * @request DELETE:/api/materialGroup/ImageStore/{country}/image/{imageStoreMaterialGroupId}
     */,

    materialGroupImageStoreImageDelete: (
      country: string,
      imageStoreMaterialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/api/materialGroup/ImageStore/${country}/image/${imageStoreMaterialGroupId}`,
        method: 'DELETE',
        ...params,
      }),
  };
  importErp = {
    /**
     * No description
     *
     * @tags ImportERP
     * @name ImportErpCreate
     * @request POST:/api/ImportERP
     */
    importErpCreate: (data: ERPImportRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/ImportERP`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      })
    /**
     * No description
     *
     * @tags ImportERP
     * @name ImportErpDatasyncAllrunsCreate
     * @request POST:/api/ImportERP/datasync/allruns
     */,

    importErpDatasyncAllrunsCreate: (params: RequestParams = {}) =>
      this.request<ERPImportResponse[], any>({
        path: `/api/ImportERP/datasync/allruns`,
        method: 'POST',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ImportERP
     * @name ImportErpDatasyncCreate
     * @request POST:/api/ImportERP/datasync/{erpImportRunId}
     */,

    importErpDatasyncCreate: (erpImportRunId: number, params: RequestParams = {}) =>
      this.request<ERPImportResponse, any>({
        path: `/api/ImportERP/datasync/${erpImportRunId}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  localization = {
    /**
     * No description
     *
     * @tags Localization
     * @name LocalizationDefinitionList
     * @request GET:/api/Localization/definition
     */
    localizationDefinitionList: (params: RequestParams = {}) =>
      this.request<LocalizationDefinition, any>({
        path: `/api/Localization/definition`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Localization
     * @name LocalizationTextCreate
     * @request POST:/api/Localization/text
     */,

    localizationTextCreate: (data: LocalizationTextModel, params: RequestParams = {}) =>
      this.request<LocalizationTextModel, any>({
        path: `/api/Localization/text`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Localization
     * @name LocalizationTextList
     * @request GET:/api/Localization/text
     */,

    localizationTextList: (query?: { sectionCode?: string; textCode?: string }, params: RequestParams = {}) =>
      this.request<LocalizationTextModel, any>({
        path: `/api/Localization/text`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Localization
     * @name LocalizationTextPartialUpdate
     * @request PATCH:/api/Localization/text
     */,

    localizationTextPartialUpdate: (data: LocalizationTextModel, params: RequestParams = {}) =>
      this.request<LocalizationTextModel, any>({
        path: `/api/Localization/text`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Localization
     * @name LocalizationTextDelete
     * @request DELETE:/api/Localization/text
     */,

    localizationTextDelete: (data: LocalizationTextModel, params: RequestParams = {}) =>
      this.request<LocalizationTextModel, any>({
        path: `/api/Localization/text`,
        method: 'DELETE',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Localization
     * @name LocalizationTranslationListList
     * @request GET:/api/Localization/translation/list
     */,

    localizationTranslationListList: (
      query?: { sectionCodes?: string; cultureCode?: string },
      params: RequestParams = {}
    ) =>
      this.request<TranslationDictionary, any>({
        path: `/api/Localization/translation/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Localization
     * @name LocalizationTextListList
     * @request GET:/api/Localization/text/list
     */,

    localizationTextListList: (query?: { sectionCodes?: string }, params: RequestParams = {}) =>
      this.request<LocalizationTextModel[], any>({
        path: `/api/Localization/text/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  mail = {
    /**
     * No description
     *
     * @tags Mail
     * @name MailList
     * @request GET:/api/Mail
     */
    mailList: (params: RequestParams = {}) =>
      this.request<MailingListResponse[], void>({
        path: `/api/Mail`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Mail
     * @name MailCreate
     * @request POST:/api/Mail
     */,

    mailCreate: (data: CreateMailRequest, params: RequestParams = {}) =>
      this.request<MailResponse, ProblemDetails | void>({
        path: `/api/Mail`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Mail
     * @name MailUpdate
     * @request PUT:/api/Mail/{id}
     */,

    mailUpdate: (id: number, data: UpdateMailRequest, params: RequestParams = {}) =>
      this.request<MailResponse, ProblemDetails | void>({
        path: `/api/Mail/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Mail
     * @name MailDelete
     * @request DELETE:/api/Mail/{id}
     */,

    mailDelete: (id: number, params: RequestParams = {}) =>
      this.request<MailResponse, ProblemDetails | void>({
        path: `/api/Mail/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Mail
     * @name MailSendCreate
     * @request POST:/api/Mail/{country}/send
     */,

    mailSendCreate: (country: string, data: MailNotificationRequest, params: RequestParams = {}) =>
      this.request<boolean, ProblemDetails>({
        path: `/api/Mail/${country}/send`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Mail
     * @name MailReminderCreate
     * @request POST:/api/Mail/reminder
     */,

    mailReminderCreate: (params: RequestParams = {}) =>
      this.request<boolean, ProblemDetails>({
        path: `/api/Mail/reminder`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  materialGroupCountry = {
    /**
     * No description
     *
     * @tags MaterialGroupCountry
     * @name MaterialGroupCountryDetail
     * @request GET:/api/MaterialGroupCountry/{country}/{materialGroupId}
     */
    materialGroupCountryDetail: (country: string, materialGroupId: number, params: RequestParams = {}) =>
      this.request<MaterialGroupCountryResponse, any>({
        path: `/api/MaterialGroupCountry/${country}/${materialGroupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupCountry
     * @name MaterialGroupCountryCreate
     * @request POST:/api/MaterialGroupCountry/{country}
     */,

    materialGroupCountryCreate: (country: string, data: MaterialGroupCountryRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/MaterialGroupCountry/${country}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  materialGroupService = {
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceCreate
     * @request POST:/api/MaterialGroupService/{country}
     */
    materialGroupServiceCreate: (country: string, data: MaterialGroupResponse, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/MaterialGroupService/${country}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceDetail
     * @request GET:/api/MaterialGroupService/{country}
     */,

    materialGroupServiceDetail: (country: string, params: RequestParams = {}) =>
      this.request<MaterialGroupResponse[], any>({
        path: `/api/MaterialGroupService/${country}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupDetail
     * @request GET:/api/MaterialGroupService/{country}/MaterialGroup/{materialGroupId}
     */,

    materialGroupServiceMaterialGroupDetail: (country: string, materialGroupId: number, params: RequestParams = {}) =>
      this.request<MaterialGroupResponse, any>({
        path: `/api/MaterialGroupService/${country}/MaterialGroup/${materialGroupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceSearchDetail
     * @request GET:/api/MaterialGroupService/{country}/search
     */,

    materialGroupServiceSearchDetail: (country: string, params: RequestParams = {}) =>
      this.request<SearchMaterialGroupResponse[], any>({
        path: `/api/MaterialGroupService/${country}/search`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceByProductIdDetail
     * @request GET:/api/MaterialGroupService/{country}/ByProductId/{productId}
     */,

    materialGroupServiceByProductIdDetail: (country: string, productId: number, params: RequestParams = {}) =>
      this.request<MaterialGroupResponse[], any>({
        path: `/api/MaterialGroupService/${country}/ByProductId/${productId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupTitleUpdate
     * @request PUT:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/title
     */,

    materialGroupServiceMaterialGroupTitleUpdate: (
      country: string,
      materialGroupId: number,
      query?: { title?: string },
      params: RequestParams = {}
    ) =>
      this.request<MaterialGroupResponse, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/title`,
        method: 'PUT',
        query: query,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupUpdate
     * @request PUT:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}
     */,

    materialGroupServiceMaterialGroupUpdate: (
      country: string,
      materialGroupId: number,
      data: MaterialGroupUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<MaterialGroupResponse, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupDelete
     * @request DELETE:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}
     */,

    materialGroupServiceMaterialGroupDelete: (country: string, materialGroupId: number, params: RequestParams = {}) =>
      this.request<boolean, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceVariantUpdate
     * @request PUT:/api/MaterialGroupService/{country}/variant/{materialGroupId}
     */,

    materialGroupServiceVariantUpdate: (
      country: string,
      materialGroupId: number,
      query?: { variantCode?: string },
      params: RequestParams = {}
    ) =>
      this.request<MaterialGroupResponse, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/variant/${materialGroupId}`,
        method: 'PUT',
        query: query,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupStorageDetail
     * @request GET:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/storage
     */,

    materialGroupServiceMaterialGroupStorageDetail: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<StorageResponse, any>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/storage`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupStorageUpdate
     * @request PUT:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/storage
     */,

    materialGroupServiceMaterialGroupStorageUpdate: (
      country: string,
      materialGroupId: number,
      data: StorageRequest,
      params: RequestParams = {}
    ) =>
      this.request<StorageResponse, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/storage`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceSubstrateMaterialGroupDetail
     * @request GET:/api/MaterialGroupService/{country}/{materialGroupId}/SubstrateMaterialGroup
     */,

    materialGroupServiceSubstrateMaterialGroupDetail: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<SubstrateMaterialGroupResponse, void>({
        path: `/api/MaterialGroupService/${country}/${materialGroupId}/SubstrateMaterialGroup`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceSubstrateMaterialGroupCreate
     * @request POST:/api/MaterialGroupService/{country}/{materialGroupId}/SubstrateMaterialGroup
     */,

    materialGroupServiceSubstrateMaterialGroupCreate: (
      country: string,
      materialGroupId: number,
      data: SubstrateMaterialGroupRequest,
      params: RequestParams = {}
    ) =>
      this.request<SubstrateMaterialGroupResponse, void>({
        path: `/api/MaterialGroupService/${country}/${materialGroupId}/SubstrateMaterialGroup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceDescriptionDetail
     * @request GET:/api/MaterialGroupService/{country}/{materialGroupId}/Description
     */,

    materialGroupServiceDescriptionDetail: (country: string, materialGroupId: number, params: RequestParams = {}) =>
      this.request<DescriptionResponseModel, void>({
        path: `/api/MaterialGroupService/${country}/${materialGroupId}/Description`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceDescriptionCreate
     * @request POST:/api/MaterialGroupService/{country}/{materialGroupId}/Description
     */,

    materialGroupServiceDescriptionCreate: (
      country: string,
      materialGroupId: number,
      data: DescriptionRequestModel,
      params: RequestParams = {}
    ) =>
      this.request<void, ProblemDetails | void>({
        path: `/api/MaterialGroupService/${country}/${materialGroupId}/Description`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupPerfectSystemDetail
     * @request GET:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/PerfectSystem
     */,

    materialGroupServiceMaterialGroupPerfectSystemDetail: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<PerfectSystemResponseModel, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/PerfectSystem`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupPerfectSystemCreate
     * @request POST:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/PerfectSystem
     */,

    materialGroupServiceMaterialGroupPerfectSystemCreate: (
      country: string,
      materialGroupId: number,
      data: PerfectSystemRequestModel,
      params: RequestParams = {}
    ) =>
      this.request<PerfectSystemResponseModel, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/PerfectSystem`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupPrepareDetail
     * @request GET:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/Prepare
     */,

    materialGroupServiceMaterialGroupPrepareDetail: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<PrepareResponseModel, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/Prepare`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupPrepareCreate
     * @request POST:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/Prepare
     */,

    materialGroupServiceMaterialGroupPrepareCreate: (
      country: string,
      materialGroupId: number,
      data: PrepareRequestModel,
      params: RequestParams = {}
    ) =>
      this.request<PrepareResponseModel, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/Prepare`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceProductHintMaterialGroupDetail
     * @request GET:/api/MaterialGroupService/{country}/{materialGroupId}/ProductHintMaterialGroup
     */,

    materialGroupServiceProductHintMaterialGroupDetail: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<ProductHintMaterialGroupResponse, void>({
        path: `/api/MaterialGroupService/${country}/${materialGroupId}/ProductHintMaterialGroup`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceProductHintMaterialGroupCreate
     * @request POST:/api/MaterialGroupService/{country}/{materialGroupId}/ProductHintMaterialGroup
     */,

    materialGroupServiceProductHintMaterialGroupCreate: (
      country: string,
      materialGroupId: number,
      data: ProductHintMaterialGroupRequest,
      params: RequestParams = {}
    ) =>
      this.request<ProductHintMaterialGroupResponse, void>({
        path: `/api/MaterialGroupService/${country}/${materialGroupId}/ProductHintMaterialGroup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupTechnicalDetailsDetail
     * @request GET:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/TechnicalDetails
     */,

    materialGroupServiceMaterialGroupTechnicalDetailsDetail: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<TechnicalDetailsResponseModel, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/TechnicalDetails`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupTechnicalDetailsCreate
     * @request POST:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/TechnicalDetails
     */,

    materialGroupServiceMaterialGroupTechnicalDetailsCreate: (
      country: string,
      materialGroupId: number,
      data: TechnicalDetailsRequestModel,
      params: RequestParams = {}
    ) =>
      this.request<TechnicalDetailsResponseModel, ProblemDetails>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/TechnicalDetails`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupWorkSafetyDetail
     * @request GET:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/WorkSafety
     */,

    materialGroupServiceMaterialGroupWorkSafetyDetail: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<WorksafetyResponseModel, any>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/WorkSafety`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceMaterialGroupWorkSafetyCreate
     * @request POST:/api/MaterialGroupService/{country}/materialGroup/{materialGroupId}/WorkSafety
     */,

    materialGroupServiceMaterialGroupWorkSafetyCreate: (
      country: string,
      materialGroupId: number,
      data: WorksafetyRequestModel,
      params: RequestParams = {}
    ) =>
      this.request<WorksafetyResponseModel, any>({
        path: `/api/MaterialGroupService/${country}/materialGroup/${materialGroupId}/WorkSafety`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags MaterialGroupService
     * @name MaterialGroupServiceVariantsDetail
     * @request GET:/api/MaterialGroupService/{country}/variants
     */,

    materialGroupServiceVariantsDetail: (country: string, params: RequestParams = {}) =>
      this.request<VariantDTO[], any>({
        path: `/api/MaterialGroupService/${country}/variants`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  pictogram = {
    /**
     * No description
     *
     * @tags Pictogram
     * @name PictogramMetadataDetail
     * @request GET:/api/Pictogram/{country}/metadata
     */
    pictogramMetadataDetail: (country: string, params: RequestParams = {}) =>
      this.request<PictogramImageResponse[], void>({
        path: `/api/Pictogram/${country}/metadata`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Pictogram
     * @name PictogramImageDetail
     * @request GET:/api/Pictogram/{country}/image
     */,

    pictogramImageDetail: (country: string, query?: { fileName?: string }, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Pictogram/${country}/image`,
        method: 'GET',
        query: query,
        ...params,
      })
    /**
     * No description
     *
     * @tags Pictogram
     * @name PictogramMaterialGroupDetail
     * @request GET:/api/Pictogram/{country}/materialGroup/{materialGroupId}
     */,

    pictogramMaterialGroupDetail: (country: string, materialGroupId: number, params: RequestParams = {}) =>
      this.request<PictogramResponse[], void>({
        path: `/api/Pictogram/${country}/materialGroup/${materialGroupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Pictogram
     * @name PictogramMaterialGroupCreate
     * @request POST:/api/Pictogram/{country}/materialGroup/{materialGroupId}
     */,

    pictogramMaterialGroupCreate: (
      country: string,
      materialGroupId: number,
      data: PictogramRequest[],
      params: RequestParams = {}
    ) =>
      this.request<PictogramResponse[], void>({
        path: `/api/Pictogram/${country}/materialGroup/${materialGroupId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Pictogram
     * @name PictogramPictogramsDetail
     * @request GET:/api/Pictogram/{country}/pictograms
     */,

    pictogramPictogramsDetail: (country: string, params: RequestParams = {}) =>
      this.request<PictogramResponseModel[], ProblemDetails>({
        path: `/api/Pictogram/${country}/pictograms`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags Pictogram
     * @name PictogramPictogramCreate
     * @request POST:/api/Pictogram/{country}/pictogram
     */,

    pictogramPictogramCreate: (country: string, data: { FullName?: string; File?: File }, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/Pictogram/${country}/pictogram`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      })
    /**
     * No description
     *
     * @tags Pictogram
     * @name PictogramPictogramDelete
     * @request DELETE:/api/Pictogram/{country}/pictogram/{fileName}
     */,

    pictogramPictogramDelete: (country: string, fileName: string, params: RequestParams = {}) =>
      this.request<boolean, ProblemDetails>({
        path: `/api/Pictogram/${country}/pictogram/${fileName}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  productService = {
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceDetail
     * @request GET:/api/ProductService/{country}
     */
    productServiceDetail: (country: string, params: RequestParams = {}) =>
      this.request<ProductGroupResponse[], any>({
        path: `/api/ProductService/${country}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceCreate
     * @request POST:/api/ProductService/{country}
     */,

    productServiceCreate: (country: string, data: ProductGroupCreateRequest, params: RequestParams = {}) =>
      this.request<ProductGroupResponse, ProblemDetails>({
        path: `/api/ProductService/${country}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceByDivisionIdDetail
     * @request GET:/api/ProductService/{country}/ByDivisionId/{divisionId}
     */,

    productServiceByDivisionIdDetail: (country: string, divisionId: number, params: RequestParams = {}) =>
      this.request<ProductGroupResponse[], any>({
        path: `/api/ProductService/${country}/ByDivisionId/${divisionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceGetByIdDetail
     * @request GET:/api/ProductService/{country}/GetById/{productId}
     */,

    productServiceGetByIdDetail: (country: string, productId: number, params: RequestParams = {}) =>
      this.request<ProductGroupResponse, any>({
        path: `/api/ProductService/${country}/GetById/${productId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceProductGroupCountryUpdate
     * @request PUT:/api/ProductService/{country}/productGroupCountry
     */,

    productServiceProductGroupCountryUpdate: (
      country: string,
      data: ProductGroupCountryRequest,
      params: RequestParams = {}
    ) =>
      this.request<ProductGroupResponse, any>({
        path: `/api/ProductService/${country}/productGroupCountry`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceProductGroupUpdate
     * @request PUT:/api/ProductService/{country}/productGroup/{productGroupId}
     */,

    productServiceProductGroupUpdate: (
      country: string,
      productGroupId: number,
      data: ProductGroupUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.request<ProductGroupResponse, ProblemDetails>({
        path: `/api/ProductService/${country}/productGroup/${productGroupId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceProductGroupDelete
     * @request DELETE:/api/ProductService/{country}/productGroup/{productGroupId}
     */,

    productServiceProductGroupDelete: (country: string, productGroupId: number, params: RequestParams = {}) =>
      this.request<boolean, ProblemDetails>({
        path: `/api/ProductService/${country}/productGroup/${productGroupId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceProductCatalogDetail
     * @request GET:/api/ProductService/{country}/ProductCatalog/{divisionId}
     */,

    productServiceProductCatalogDetail: (country: string, divisionId: number, params: RequestParams = {}) =>
      this.request<ProductCatalogResponse[], any>({
        path: `/api/ProductService/${country}/ProductCatalog/${divisionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceProductCatalogCreate
     * @request POST:/api/ProductService/{country}/ProductCatalog/{divisionId}
     */,

    productServiceProductCatalogCreate: (
      country: string,
      divisionId: number,
      data: ProductCatalogSaveRequest,
      params: RequestParams = {}
    ) =>
      this.request<ProductCatalogResponse[], any>({
        path: `/api/ProductService/${country}/ProductCatalog/${divisionId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceProductCatalogFileDetail
     * @request GET:/api/ProductService/{country}/ProductCatalog/{divisionId}/file
     */,

    productServiceProductCatalogFileDetail: (country: string, divisionId: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/ProductService/${country}/ProductCatalog/${divisionId}/file`,
        method: 'GET',
        ...params,
      })
    /**
     * No description
     *
     * @tags ProductService
     * @name ProductServiceMaterialGroupsForProductCatalogDetail
     * @request GET:/api/ProductService/{country}/MaterialGroupsForProductCatalog/{divisionId}
     */,

    productServiceMaterialGroupsForProductCatalogDetail: (
      country: string,
      divisionId: number,
      params: RequestParams = {}
    ) =>
      this.request<ProductCatalogAvailableMaterialGroupsResponse[], any>({
        path: `/api/ProductService/${country}/MaterialGroupsForProductCatalog/${divisionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  quickLink = {
    /**
     * No description
     *
     * @tags QuickLink
     * @name QuickLinkDetail
     * @request GET:/api/QuickLink/{path}
     */
    quickLinkDetail: (path: string, params: RequestParams = {}) =>
      this.request<QuickLinkResponse, ProblemDetails>({
        path: `/api/QuickLink/${path}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags QuickLink
     * @name QuickLinkList
     * @request GET:/api/QuickLink
     */,

    quickLinkList: (params: RequestParams = {}) =>
      this.request<QuickLinkResponse[], ProblemDetails>({
        path: `/api/QuickLink`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags QuickLink
     * @name QuickLinkCreate
     * @request POST:/api/QuickLink
     */,

    quickLinkCreate: (data: QuickLinkRequest, params: RequestParams = {}) =>
      this.request<QuickLinkResponse, ProblemDetails>({
        path: `/api/QuickLink`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags QuickLink
     * @name QuickLinkDelete
     * @request DELETE:/api/QuickLink/{id}
     */,

    quickLinkDelete: (id: number, params: RequestParams = {}) =>
      this.request<boolean, ProblemDetails>({
        path: `/api/QuickLink/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  sealOfApprovalAndNorm = {
    /**
     * No description
     *
     * @tags SealOfApprovalAndNorm
     * @name SealOfApprovalAndNormImagesDetail
     * @request GET:/api/SealOfApprovalAndNorm/{country}/images
     */
    sealOfApprovalAndNormImagesDetail: (country: string, params: RequestParams = {}) =>
      this.request<SealOfApprovalImageResponse[], void>({
        path: `/api/SealOfApprovalAndNorm/${country}/images`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags SealOfApprovalAndNorm
     * @name SealOfApprovalAndNormImageDetail
     * @request GET:/api/SealOfApprovalAndNorm/{country}/image
     */,

    sealOfApprovalAndNormImageDetail: (country: string, query?: { fileName?: string }, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/SealOfApprovalAndNorm/${country}/image`,
        method: 'GET',
        query: query,
        ...params,
      })
    /**
     * No description
     *
     * @tags SealOfApprovalAndNorm
     * @name SealOfApprovalAndNormMaterialGroupCreate
     * @request POST:/api/SealOfApprovalAndNorm/{country}/materialGroup/{materialGroupId}
     */,

    sealOfApprovalAndNormMaterialGroupCreate: (
      country: string,
      materialGroupId: number,
      data: SealOfApprovalAndNormMaterialGroupRequest,
      params: RequestParams = {}
    ) =>
      this.request<boolean, void>({
        path: `/api/SealOfApprovalAndNorm/${country}/materialGroup/${materialGroupId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags SealOfApprovalAndNorm
     * @name SealOfApprovalAndNormMaterialGroupDetail
     * @request GET:/api/SealOfApprovalAndNorm/{country}/materialGroup/{materialGroupId}
     */,

    sealOfApprovalAndNormMaterialGroupDetail: (country: string, materialGroupId: number, params: RequestParams = {}) =>
      this.request<SealOfApprovalAndNormMaterialGroupResponse, void>({
        path: `/api/SealOfApprovalAndNorm/${country}/materialGroup/${materialGroupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags SealOfApprovalAndNorm
     * @name SealOfApprovalAndNormSealOfApprovalCreate
     * @request POST:/api/SealOfApprovalAndNorm/{country}/SealOfApproval
     */,

    sealOfApprovalAndNormSealOfApprovalCreate: (
      country: string,
      data: { FullName?: string; Category?: string; FileName?: string; File?: File },
      params: RequestParams = {}
    ) =>
      this.request<boolean, ProblemDetails>({
        path: `/api/SealOfApprovalAndNorm/${country}/SealOfApproval`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags SealOfApprovalAndNorm
     * @name SealOfApprovalAndNormSealOfApprovalUpdate
     * @request PUT:/api/SealOfApprovalAndNorm/{country}/SealOfApproval
     */,

    sealOfApprovalAndNormSealOfApprovalUpdate: (
      country: string,
      query?: { fileName?: string; oldCategoryName?: string; newCategoryName?: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ProblemDetails>({
        path: `/api/SealOfApprovalAndNorm/${country}/SealOfApproval`,
        method: 'PUT',
        query: query,
        ...params,
      })
    /**
     * No description
     *
     * @tags SealOfApprovalAndNorm
     * @name SealOfApprovalAndNormSealOfApprovalDelete
     * @request DELETE:/api/SealOfApprovalAndNorm/{country}/SealOfApproval/{path}/{category}
     */,

    sealOfApprovalAndNormSealOfApprovalDelete: (
      country: string,
      path: string,
      category: string,
      params: RequestParams = {}
    ) =>
      this.request<boolean, ProblemDetails>({
        path: `/api/SealOfApprovalAndNorm/${country}/SealOfApproval/${path}/${category}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  search = {
    /**
     * No description
     *
     * @tags Search
     * @name SearchDetail
     * @request GET:/api/search/{searchText}/{countryCode}
     */
    searchDetail: (searchText: string, countryCode: string, params: RequestParams = {}) =>
      this.request<SearchResponse[], ProblemDetails>({
        path: `/api/search/${searchText}/${countryCode}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  technicalDatasheetAttachment = {
    /**
     * No description
     *
     * @tags TechnicalDatasheetAttachment
     * @name TechnicalDatasheetAttachmentMaterialGroupDetail
     * @request GET:/api/TechnicalDatasheetAttachment/{country}/materialGroup/{materialGroupId}
     */
    technicalDatasheetAttachmentMaterialGroupDetail: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<TechnicalDatasheetAttachmentResponse[], void>({
        path: `/api/TechnicalDatasheetAttachment/${country}/materialGroup/${materialGroupId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags TechnicalDatasheetAttachment
     * @name TechnicalDatasheetAttachmentMaterialGroupCreate
     * @request POST:/api/TechnicalDatasheetAttachment/{country}/materialGroup/{materialGroupId}
     */,

    technicalDatasheetAttachmentMaterialGroupCreate: (
      country: string,
      materialGroupId: number,
      data: { files?: File[] },
      params: RequestParams = {}
    ) =>
      this.request<TechnicalDatasheetAttachmentResponse[], ProblemDetails | void>({
        path: `/api/TechnicalDatasheetAttachment/${country}/materialGroup/${materialGroupId}`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags TechnicalDatasheetAttachment
     * @name TechnicalDatasheetAttachmentDetail
     * @request GET:/api/TechnicalDatasheetAttachment/{country}/{technicalDatasheetAttachmentId}
     */,

    technicalDatasheetAttachmentDetail: (
      country: string,
      technicalDatasheetAttachmentId: number,
      params: RequestParams = {}
    ) =>
      this.request<TechnicalDatasheetAttachmentResponse, void>({
        path: `/api/TechnicalDatasheetAttachment/${country}/${technicalDatasheetAttachmentId}`,
        method: 'GET',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags TechnicalDatasheetAttachment
     * @name TechnicalDatasheetAttachmentDelete
     * @request DELETE:/api/TechnicalDatasheetAttachment/{country}/{technicalDatasheetAttachmentId}
     */,

    technicalDatasheetAttachmentDelete: (
      country: string,
      technicalDatasheetAttachmentId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, ProblemDetails | void>({
        path: `/api/TechnicalDatasheetAttachment/${country}/${technicalDatasheetAttachmentId}`,
        method: 'DELETE',
        ...params,
      })
    /**
     * No description
     *
     * @tags TechnicalDatasheetAttachment
     * @name TechnicalDatasheetAttachmentFileDetail
     * @request GET:/api/TechnicalDatasheetAttachment/{country}/{technicalDatasheetAttachmentId}/file
     */,

    technicalDatasheetAttachmentFileDetail: (
      country: string,
      technicalDatasheetAttachmentId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/api/TechnicalDatasheetAttachment/${country}/${technicalDatasheetAttachmentId}/file`,
        method: 'GET',
        ...params,
      }),
  };
  tmbGenerator = {
    /**
     * No description
     *
     * @tags TMBGenerator
     * @name TmbGeneratorMaterialgroupGenerateworddocumentCreate
     * @request POST:/api/TMBGenerator/{country}/materialgroup/{materialGroupId}/generateworddocument
     */
    tmbGeneratorMaterialgroupGenerateworddocumentCreate: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<DocumentResponse, any>({
        path: `/api/TMBGenerator/${country}/materialgroup/${materialGroupId}/generateworddocument`,
        method: 'POST',
        format: 'json',
        ...params,
      })
    /**
     * No description
     *
     * @tags TMBGenerator
     * @name TmbGeneratorMaterialgroupGenerateexternallayoutworddocumentCreate
     * @request POST:/api/TMBGenerator/{country}/materialgroup/{materialGroupId}/generateexternallayoutworddocument
     */,

    tmbGeneratorMaterialgroupGenerateexternallayoutworddocumentCreate: (
      country: string,
      materialGroupId: number,
      params: RequestParams = {}
    ) =>
      this.request<DocumentResponse, any>({
        path: `/api/TMBGenerator/${country}/materialgroup/${materialGroupId}/generateexternallayoutworddocument`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
}

/**
 * React Hook to use.
 */

import * as React from 'react';
import { CurrentCultureStateContext } from '../contexts';

export function useMurexinPimContextApi() {
  const { currentCulture } = React.useContext(CurrentCultureStateContext);
  const [api] = React.useState(
    new MurexinPimContextApi({
      baseUrl: `${window.apiUrl}`,
      securityWorker: async () => {
        let headers: object = {
          'Accept-Language': currentCulture,
        };

        return { headers } as RequestParams;
      },
    })
  );

  return api;
}
